// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================ BASE STYLES ================ */
:root {
  --primary-color: #2d9cdb;
  --primary-hover: #1b82c6;
  --secondary-color: #0e1940;
  --secondary-hover: #132451;
  --accent-color: #f7b731;
  --accent-contrast: #111;
  --text-light: #eef2ff;
  --text-dark: #111827;
  --text-muted: #64748b;
  --bg: #f7f9fc;
  --surface: #ffffff;
  --surface-soft: #f3f6ff;
  --border: #d1d7e2;
  --shadow: rgba(23, 71, 132, 0.12);
  --card-shadow: rgba(23, 71, 132, 0.08);
  --danger: #ef4444;
  --success: #22c55e;
}

* {
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  margin: 0;
  font-family: 'Zain', sans-serif;
}

body {
  margin: 0;
  padding: 0;
  background-color: var(--bg);
  color: var(--text-dark);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

#root {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

body.dark-mode {
  background-color: #0f172a !important;
  color: #e2e8f0;
}

body.dark-mode .navbar {
  background: #1e293b;
  border-bottom: 1px solid #334155;
}

body.dark-mode .navbar-container a,
body.dark-mode .nav-title,
body.dark-mode .nav-cart,
body.dark-mode .phone-text,
body.dark-mode .dropdown-menu a,
body.dark-mode .dropdown-menu button,
body.dark-mode .product-description,
body.dark-mode .product-name,
body.dark-mode .add-to-cart-btn,
body.dark-mode .product-info h3,
body.dark-mode .product-info p,
body.dark-mode button,
body.dark-mode .item-total,
body.dark-mode .item-tot-price-number

{
  color: #dbeafe !important;
}

body.dark-mode .footer-text,
body.dark-mode .footer-brand {
  color: #cbd5e1 !important;
}

body.dark-mode .product-card,
body.dark-mode .cart-card,
body.dark-mode .checkout-container,
body.dark-mode .product-card-details,
body.dark-mode .banner-fallback,
body.dark-mode .basket-summary,
body.dark-mode .cart-summary {
  background: #1e293b;
  border-color: #334155;
}

body.dark-mode .footer {
  background: #0f172a;
  border-top: 1px solid #334155;
}

body.dark-mode .product-image,
body.dark-mode .cart-img,
body.dark-mode .banner-image {
  filter: brightness(0.9);
  -webkit-filter: brightness(0.9);
}

.main-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  flex: 1 1;
}
.nav-title {
  color: #1e293b !important;
  font-size: 1.1rem;
  font-weight: bold;
  white-space: nowrap;
}

.shop-shell-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  flex: 1 1;
  background: var(--bg);
}
body.dark-mode .shop-shell-wrapper {
  background: #0f172a;
}

.shop-shell-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 1rem;
}

.page-center {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0;
}

.product-list {
  width: 100%;
  display: flex;
  flex-direction: column;
}

/* ================ LAYOUT COMPONENTS ================ */
.container {
  width: 100%;
  margin: 0 auto;
}


/* ================ NAVBAR ================ */

.navbar {
  background: #f0f4f9;
  padding: 0;
  display: flex;
  align-items: center;
  position: sticky;
  width: 100%;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border-bottom: 1px solid #e2e8f0;
}

.navbar-container {
  max-width: 1800px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 72px;
  width: 100%;
  color: var(--text-light);
}

.nav-left {
  display: flex;
  align-items: center;
  height: 100%;
  flex: 1 1;
}

.nav-logo {
  height: 50px;
  width: auto;
  object-fit: contain;
  padding-right: 30px;
}



/* Shimmer Animation */
.nav-center {
  flex: 1 1;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border: #212831 solid 1px;
  background-color: #eeeeee;
  padding: 10px 20px;
  border-radius: 15%;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  -webkit-border-radius: 15%;
  -moz-border-radius: 15%;
  -ms-border-radius: 15%;
  -o-border-radius: 15%;
}

@media (max-width: 900px) {
  .nav-center {
    display: none;
  }
}

.nav-title {
  color: #1e293b;
  font-size: 1.1rem;
  font-weight: bold;
  white-space: nowrap;
  position: relative;
  z-index: 1;
}

/* Shimmer Effect */
/* Simplified name text: no animation */
.shimmer-text {
  background: none;
  background-clip: unset;
  color: inherit;
  animation: none;
}

body.dark-mode .nav-center {
  border-color: #475569;
  background: rgba(255, 255, 255, 0.05);
}

body.dark-mode .shimmer-text {
  background: none;
  background-clip: unset;
  color: inherit;
  animation: none;
}

.nav-right {
    display: flex;
    align-items: center;
    gap: 1rem;
    font-size: 1rem;
    flex: 1 1;
    justify-content: flex-end;
}

.dark-mode-toggle {
  border: 1px solid #cbd5e1;
  background: rgba(0, 0, 0, 0.05);
  color: #1e293b;
  border-radius: 999px;
  padding: 0.8rem 1rem;
  cursor: pointer;
  font-size: 0.95rem;
  transition: transform 0.2s ease, background 0.2s ease;
}

.dark-mode-toggle:hover {
  transform: translateY(-1px);
  background: rgba(0, 0, 0, 0.1);
}

/* Theme Buttons Group */
.theme-buttons-group {
  display: flex;
  gap: 0.5rem;
  border: 1px solid #cbd5e1;  background: rgba(0, 0, 0, 0.05);  border-radius: 999px;
  padding: 0.3rem;
}

.theme-btn {
  background: transparent;
  border: none;
  color: #1e293b;
  padding: 0.2rem 0.3rem;
  cursor: pointer;
  font-size: 1rem;
  border-radius: 8px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.theme-btn:hover {
  background: rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

.theme-btn.active {
  background: rgba(0, 0, 0, 0.15);
  box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.1);
}

body.dark-mode .theme-btn {
  color: #dbeafe;
}

body.dark-mode .theme-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

body.dark-mode .theme-btn.active {
  background: rgba(255, 255, 255, 0.2);
}

body.dark-mode .nav-cart {
  color: #dbeafe;
}

body.dark-mode .nav-cart:hover {
  color: #93c5fd;
}

body.dark-mode .phone-button {
  color: #dbeafe;
}

body.dark-mode .phone-button:hover {
  color: #93c5fd;
}

body.dark-mode .desktop-only a {
  color: #dbeafe;
}

body.dark-mode .hamburger-button span {
  background: #dbeafe;
}

body.dark-mode .theme-buttons-group {
  border-color: #475569;
  background: rgba(255, 255, 255, 0.05);
}

body.dark-mode .dark-mode-toggle {
  border-color: #475569;
  background: rgba(255, 255, 255, 0.05);
  color: #dbeafe;
}

body.dark-mode .dark-mode-toggle:hover {
  background: rgba(255, 255, 255, 0.1);
}

.nav-cart {
  font-size: 1.5rem;
  color: #0c131f;
  display: flex;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;
}
.cart-count {
  color: #2b5ba7;
}

body.dark-mode .cart-count {
  color: #93c5fd;
}

.nav-cart:hover {
  color: #2d9cdb;
}

.nav-logo {
  height: 50px;
  width: auto;
  object-fit: contain;
  padding-right: 30px;
}



.nav-right {
    display: flex;
    align-items: center;
    gap: 1rem;
    font-size: 1rem;
}

.nav-phone {
    display: flex;
    align-items: center;
    white-space: nowrap;
    font-size: 0.95rem;
    color: #9ad12d;
}

.phone-text {
    margin-left: 0.3rem;
    color: #1e293b;}

.dropdown-wrapper {
   position: relative;
}   

.phone-button {
  background: none;
  border: none;
  color: #1e293b;
  cursor: pointer;
  font-size: 1rem;
  font-family: inherit;
  transition: color 0.2s ease;
}

.phone-button:hover {
  color: #2d9cdb;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #333;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 160px;
  z-index: 1000;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.dropdown-link {
    white-space: nowrap;
  font-size: 18px !important; /* or your preferred size */
  display: inline-block; /* or block if needed */
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis; /* optional, for long items */
}

a.dropdown-link {
  font-size: 15px !important;
  color: #333;
  padding: 8px 12px;
  display: block;
  text-decoration: none;
}


.dropdown-menu a,
.dropdown-menu button {
  color: white;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  padding: 0.5rem 1rem;
  text-decoration: none;
  font-size: 0.95rem;
}

.dropdown-menu a:hover,
.dropdown-menu button:hover {
  background-color: #444;
      font-size: 16px;
}

.dropdown-link:hover {
  background-color: #f0f0f0;
  color: #000;
  cursor: pointer;
}


.nav-cart {
  font-size: 1.5rem;
  color: white;
  text-shadow: 1px 1px 2px #000;
  display: flex;
  align-items: center;
}

.nav-center {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}

.nav-title {
  color: #ccc;
  font-size: 1.1rem;
  font-weight: bold;
  white-space: nowrap;
}

.nav-link {
  color: #ccc;
  text-decoration: none;
  white-space: nowrap;
}

/* Hide mobile hamburger on desktop */
.mobile-only {
  display: none;
}

/* Show full menu on desktop */
.desktop-only {
  display: flex;
  gap: 1px;
  align-items: center;
}

.desktop-only a {
  color: #1e293b;           
  font-size: 1.6rem;        
  text-decoration: none;   
  padding-right: 50px;
  transition: color 0.2s ease;
}

.desktop-only a:hover {
  color: var(--primary-color); 
}


.hamburger-wrapper {
  display: none;
}

.hamburger-menu {
    position: relative;
    display: inline-block;
}

.hamburger-button {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 2rem;
    height: 2rem;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    margin-left: 1rem;
}

.hamburger-button span {
    width: 25px;
    height: 3px;
    background: #1e293b;
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;
}

.hamburger-button.open span:first-child {
    transform: rotate(45deg);
}

.hamburger-button.open span:nth-child(2) {
    opacity: 0;
}

.hamburger-button.open span:last-child {
    transform: rotate(-45deg);
}


.hamburger-dropdown {
  position: absolute;
  top: 40px;
  left: 0;
  background: rgb(245, 222, 222);
  border: 1px solid #3b6747;
  padding: 10px;
  border-radius: 6px;
  box-shadow: 0px 4px 18px rgba(220, 4, 4, 0.1);
  z-index: 999;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.hamburger-dropdown a, 
.hamburger-dropdown button {
    padding: 1.5rem;
    text-decoration: none;
    color: #de6767;
    text-align: right;
    background: none;
    border: none;
    cursor: pointer;
}

.hamburger-dropdown button {
    text-align: right;
}

/* ================ PRODUCT GRID ================ */
/* .product-grid {
  margin-top: 5px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1.5rem;
  padding: 1rem;
} */

.product-grid {
  margin: 25px auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 2rem;
  padding: 0 1rem;
  max-width: 1200px;
  width: 100%;
}

.product-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 22px 50px rgba(15, 23, 42, 0.14);
}

.product-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 18px;
  padding: 16px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
  direction: rtl;
}

.product-image {
  width: 100%;
  height: 200px;
  object-fit:fill;
  margin-bottom: 10px;
  border-radius: 4px;
  padding: 10px;
}

.product-info {
  padding: 15px 0;
  text-align: center;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.product-info h3 {
  font-size: 1.1rem;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.product-info p {
  font-weight: bold;
  margin-bottom: 12px;
  color: var(--text-dark);
}

.product-card {
  background: var(--pure-white);
  border: 1px solid #979cdb;
  border-radius: 8px;
  padding: 2px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
  direction: rtl;
}


.product-card-details {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 16px;
  margin: 30px auto;
  max-width: 600px;
  border: 1px solid #979cdb;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
  background-color: #fff;
  text-align: center;
  transition: all 0.3s ease;
}



.product-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  gap: 20px;
}


.details-image {
  width: 500px;
  height: 300px;
  object-fit: contain;
}

.details-info {
  text-align: center;
  max-width: 600px;
}

/* ================ BUTTONS ================ */
.btn {
  border: 1px solid #242ec1;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 0.9rem;
}

.add-to-cart-btn {
  padding: 10px 20px;
  background-color: var(--pure-white);
  border: 1px solid #979cdb;
  color: rgb(0, 0, 0);
  border-radius: 20px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 15px;
}

.add-to-cart-btn:hover {
  background-color: var(--primary-hover);
  color: aqua;
}



.btn-remove:hover {
  transform: scale(1.05);
}

.btn-checkout {
  background: linear-gradient(to right, var(--primary-color), var(--primary-hover)); 
  color: white;
  padding: 12px 24px;
  border-radius: 20px;
  font-size: 1rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}
body.dark-mode .btn-checkout {
  color: #000 !important;
}

.btn-checkout:hover {
  transform: scale(1.10);
   color: aqua;
}

.btn-add {
    width: 50%;
    padding: 8px 10px;
    font-size: 0.6rem;
}

/* ================ CART ANIMATIONS ================ */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* ================ CART ================ */
.cart-container {
  padding: 3rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  min-height: 60vh;
}

.cart-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  position: relative;
  margin-bottom: 1rem;
}

.cart-header h2 {
  font-size: 2rem;
  font-weight: 700;
  color: var(--secondary-color);
  margin: 0;
  animation: slideInUp 0.6s ease-out;
}

body.dark-mode .cart-header h2 {
  color: #e2e8f0;
}

.cart-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, var(--primary-color), #1e7fa3);
  color: white;
  border-radius: 50%;
  font-weight: 700;
  font-size: 1rem;
  animation: slideInUp 0.6s ease-out 0.1s both;
  box-shadow: 0 4px 12px rgba(45, 156, 219, 0.3);
}

.cart-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.75rem;
  padding: 0;
  list-style: none;
  width: 100%;
}

.cart-item {
  opacity: 0;
  animation: slideInUp 0.5s ease-out forwards;
  animation-delay: calc(var(--item-index) * 0.08s);
}

.cart-card {
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, var(--surface) 0%, #f8fafb 100%);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 1.5rem;
  gap: 1.25rem;
  height: 100%;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.cart-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--primary-color), var(--accent-color));
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.4s ease;
}

.cart-card:hover::before {
  transform: scaleX(1);
}

.cart-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(45, 156, 219, 0.15);
  border-color: var(--primary-color);
}

body.dark-mode .cart-card {
  background: linear-gradient(135deg, #1e293b 0%, #1a2536 100%);
  border-color: #334155;
}

.cart-image-wrapper {
  width: 100%;
  height: 200px;
  border-radius: 12px;
  overflow: hidden;
  background: var(--surface-soft);
  border: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
}

.cart-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.cart-item:hover .cart-img {
  transform: scale(1.08);
}

.cart-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.cart-name {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-dark);
  margin: 0;
  line-height: 1.4;
  text-align: right;
}

body.dark-mode .cart-name {
  color: #e2e8f0;
}

.cart-price {
  font-size: 1.3rem;
  color: var(--primary-color);
  font-weight: 700;
  margin: 0.5rem 0 0 0;
}

body.dark-mode .cart-price {
  color: #60a5fa;
}

.item-total {
  font-size: 0.95rem;
  color: var(--text-muted);
  margin: 0.5rem 0 0 0;
  text-align: right;
}


.item-total strong {
  color: var(--primary-color);
  font-weight: 700;
}

.cart-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 0.75rem;
  padding: 0.75rem;
  background: var(--surface-soft);
  border-radius: 10px;
}

.qty-btn {
  padding: 0.5rem 0.875rem;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.2s ease;
  min-width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qty-btn:hover {
  background: var(--primary-hover);
  transform: scale(1.05);
}

.qty-btn:active {
  transform: scale(0.95);
}

.qty-display {
  min-width: 40px;
  text-align: center;
  font-weight: 600;
  color: var(--text-dark);
  font-size: 1rem;
}

body.dark-mode .qty-display {
  color: #080b0f;
}

.btn-remove {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  transition: all 0.2s ease;
}

.btn-icon {
  font-size: 1.2rem;
}
body.dark-mode .btn-icon {
  color: #ef4444;
}

.btn-remove:hover {
  background: rgba(239, 68, 68, 0.2);
  transform: scale(1.1) rotate(10deg);
}

.btn-remove:active {
  transform: scale(0.95);
}

body.dark-mode .btn-remove {
  background: rgba(239, 68, 68, 0.15);
  color: #f87171;
}

.cart-summary {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
  padding: 2rem;
  background: linear-gradient(135deg, var(--primary-color), #1e7fa3);
  border-radius: 16px;
  color: white;
  box-shadow: 0 8px 24px rgba(45, 156, 219, 0.2);
  animation: fadeInScale 0.6s ease-out 0.3s both;
}

body.dark-mode .cart-summary {
  background: linear-gradient(135deg, #0f172a, #1a2f4a);
  border: 1px solid #334155;
}

.cart-total-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.total-label {
  font-size: 1rem;
  font-weight: 500;
  opacity: 0.95;
  margin: 0;
}

.total-amount {
  font-size: 2rem;
  font-weight: 800;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.btn-checkout {
  padding: 1rem 3rem;
  background: white;
  color: var(--primary-color);
  border: none;
  border-radius: 10px;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 250px;
}

.btn-checkout:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  background: #f0f9ff;
}

.btn-checkout:active {
  transform: translateY(0);
}

body.dark-mode .btn-checkout {
  background: #e2e8f0;
  color: #0f172a;
}

body.dark-mode .btn-checkout:hover {
  background: #f0f9ff;
}

.empty-cart {
  min-height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  color: var(--text-muted);
  text-align: center;
  padding: 3rem;
}

body.dark-mode .empty-cart {
  color: #94a3b8;
}

/* ================ BANNER ================ */

.banner-wrapper {
  width: 62%;
  margin: 0 auto;
  padding: 0;
  display: flex;
  justify-content: center;
}

@media screen and (max-width: 768px) {
  .banner-wrapper {
    width: 90%;
  }
}
@media screen and (max-width: 1900px) {
  .banner-wrapper {
    width: 80%;
  }
}


.animated-banner {
  width: 100%;
  height: 420px;
  overflow: hidden;
  border-radius: 0;
  position: relative;
  margin: 0;
  box-shadow: none;
  background: linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%);
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0;
}

.banner-fallback {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%);
  color: #0f172a;
  border-radius: 0;
}

body.dark-mode .animated-banner {
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
}

body.dark-mode .banner-fallback {
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  color: #e2e8f0;
}

.banner-fallback-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  text-align: center;
}

.banner-fallback-icon {
  width: 100px;
  height: 100px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.9);
  font-size: 3.5rem;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.15);
}

.banner-fallback-content strong {
  display: block;
  font-size: 1.5rem;
  font-weight: 700;
}

.banner-fallback-content p {
  margin: 0.5rem 0 0;
  color: inherit;
  opacity: 0.85;
  font-size: 1rem;
}

.checkout-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.checkout-page main {
  flex: 1 1; /* Pushes footer down */
}

/* ================ FOOTER ================ */
.footer {
  margin-top: auto;
  padding: 24px 20px;
  background: #f0f4f9;
  color: #475569;
  flex-shrink: 0;
  width: 100%;
  border-top: 1px solid #e2e8f0;
}

.footer-text,
.footer-brand {
  color: #475569;
  font-size: 0.95rem;
}

.footer-brand {
  font-weight: 600;
}

.footer-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  max-width: 1200px;
  margin: 0 auto;
}

.footer-left,
.footer-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* ================ CHECKOUT ================ */
.checkout-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 3rem 1.5rem;
  background: linear-gradient(135deg, var(--surface) 0%, #f8fafb 100%);
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(45, 156, 219, 0.1);
  direction: rtl;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}

body.dark-mode .checkout-container {
  background: linear-gradient(135deg, #1e293b 0%, #1a2536 100%);
  border: 1px solid #334155;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.checkout-title {
  text-align: center;
  margin-bottom: 1.5rem;
  color: var(--secondary-color);
  font-size: 2rem;
  font-weight: 700;
  animation: slideInUp 0.6s ease-out;
}

body.dark-mode .checkout-title {
  color: #e2e8f0;
}

.checkout-form {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.checkout-form input,
.checkout-form select {
  padding: 0.875rem 1rem;
  border-radius: 10px;
  border: 1px solid var(--border);
  font-size: 1rem;
  font-family: 'Zain', sans-serif;
  transition: all 0.3s ease;
  background: var(--surface);
  color: var(--text-dark);
}

.checkout-form input:focus,
.checkout-form select:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(45, 156, 219, 0.1);
}

body.dark-mode .checkout-form input,
body.dark-mode .checkout-form select {
  background: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}

body.dark-mode .checkout-form input:focus,
body.dark-mode .checkout-form select:focus {
  border-color: #60a5fa;
  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.1);
}

/* ================ FORM SECTIONS ================ */
.customer-info-section,
.payment-method-section {
  padding: 1.75rem;
  background: linear-gradient(135deg, #ffffff 0%, #f9fafc 100%);
  border-radius: 14px;
  border: 1px solid var(--border);
  transition: all 0.3s ease;
}

body.dark-mode .customer-info-section,
body.dark-mode .payment-method-section {
  background: linear-gradient(135deg, #1e293b 0%, #1a2536 100%);
  border-color: #334155;
}

.full-name-input,
.address-input {
  padding: 0.875rem 1rem;
  font-size: 1rem;
  width: 100%;
  border: 1px solid var(--border);
  border-radius: 10px;
  margin-bottom: 1rem;
  font-family: 'Zain', sans-serif;
  background: var(--surface);
  color: var(--text-dark);
  transition: all 0.3s ease;
}

.full-name-input:focus,
.address-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(45, 156, 219, 0.1);
}

body.dark-mode .full-name-input,
body.dark-mode .address-input {
  background: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}

.location-selectors {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1rem;
  width: 100%;
  flex-wrap: wrap;
}

.state-select,
.district-select {
  flex: 1 1;
  min-width: 200px;
  padding: 0.875rem 1rem;
  font-size: 1rem;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--surface);
  color: var(--text-dark);
  font-family: 'Zain', sans-serif;
  transition: all 0.3s ease;
  cursor: pointer;
}

.state-select:focus,
.district-select:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(45, 156, 219, 0.1);
}

body.dark-mode .state-select,
body.dark-mode .district-select {
  background: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}

/* ================ PAYMENT METHOD ================ */
.payment-method-section {
  margin-bottom: 0;
}

.payment-selector {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.payment-title {
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
  color: var(--text-dark);
  font-size: 1.05rem;
}

body.dark-mode .payment-title {
  color: #e2e8f0;
}

.payment-type-select {
  padding: 0.875rem 1.5rem;
  border-radius: 10px;
  border: 2px solid var(--primary-color);
  min-width: 200px;
  font-size: 1rem;
  background: var(--surface);
  color: var(--text-dark);
  font-family: 'Zain', sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.payment-type-select:hover {
  border-color: var(--primary-hover);
  box-shadow: 0 4px 12px rgba(45, 156, 219, 0.15);
}

body.dark-mode .payment-type-select {
  background: #1e293b;
  border-color: #60a5fa;
  color: #e2e8f0;
}

/* ================ ORDER SUMMARY ================ */
.checkout-summary {
  list-style: none;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.75rem;
  margin-bottom: 2rem;
}

.checkout-summary li {
  margin-bottom: 0;
  animation: slideInUp 0.5s ease-out forwards;
}

.order-items-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.75rem;
  margin-bottom: 2rem;
  list-style: none;
  padding: 0;
}

.order-item-card {
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 1.25rem;
  background: linear-gradient(135deg, #ffffff 0%, #f9fafc 100%);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
  text-align: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.order-item-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(45, 156, 219, 0.15);
  border-color: var(--primary-color);
}

body.dark-mode .order-item-card {
  background: linear-gradient(135deg, #1e293b 0%, #1a2536 100%);
  border-color: #334155;
}

.order-item-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 10px;
  margin-bottom: 1rem;
  background: var(--surface-soft);
  border: 1px solid var(--border);
}

.order-item-details {
  font-size: 1rem;
  color: var(--text-dark);
  margin-bottom: 0.75rem;
}

body.dark-mode .order-item-details {
  color: #e2e8f0;
}

.order-item-price {
  font-weight: 700;
  color: var(--primary-color);
  font-size: 1.2rem;
}

body.dark-mode .order-item-price {
  color: #60a5fa;
}

.checkout-summary {
  padding: 1.75rem;
  background: linear-gradient(135deg, var(--primary-color), #1e7fa3);
  border-radius: 14px;
  color: white;
  box-shadow: 0 8px 24px rgba(45, 156, 219, 0.2);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

body.dark-mode .checkout-summary {
  background: linear-gradient(135deg, #0f172a, #1a2f4a);
  border: 1px solid #334155;
}

.checkout-summary li {
  display: flex;
  justify-content: space-between;
  padding: 0.75rem 0;
  font-size: 1.1rem;
  font-weight: 500;
  animation: none;
}

.checkout-summary li:last-child {
  border-top: 2px solid rgba(255, 255, 255, 0.2);
  padding-top: 1rem;
  margin-top: 1rem;
  font-size: 1.3rem;
  font-weight: 700;
}

/* ================ OTP VERIFICATION ================ */
.otp-verification-container {
  max-width: 550px;
  margin: 3rem auto;
  padding: 2.5rem;
  text-align: center;
  border-radius: 16px;
  border: 1px solid var(--border);
  background: linear-gradient(135deg, var(--surface) 0%, #f8fafb 100%);
  box-shadow: 0 8px 24px rgba(45, 156, 219, 0.12);
}

body.dark-mode .otp-verification-container {
  background: linear-gradient(135deg, #1e293b 0%, #1a2536 100%);
  border-color: #334155;
}

.otp-title {
  font-family: 'Tajawal', sans-serif;
  margin-bottom: 1.5rem;
  color: var(--secondary-color);
  font-size: 1.8rem;
  font-weight: 700;
}

body.dark-mode .otp-title {
  color: #e2e8f0;
}

.phone-input-container {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  width: 100%;
}

.country-select,
.phone-input {
  padding: 0.875rem 1rem;
  font-size: 1rem;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--surface);
  color: var(--text-dark);
  font-family: 'Zain', sans-serif;
  transition: all 0.3s ease;
}

.country-select:focus,
.phone-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(45, 156, 219, 0.1);
}

body.dark-mode .country-select,
body.dark-mode .phone-input {
  background: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}

.phone-input {
  flex: 1 1;
}

.otp-instructions {
  margin-bottom: 1.5rem;
  color: var(--text-muted);
  font-size: 1.05rem;
  line-height: 1.6;
}

body.dark-mode .otp-instructions {
  color: #94a3b8;
}

.otp-inputs-container {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  margin-bottom: 2rem;
}

.otp-input {
  width: 3.25rem;
  height: 3.25rem;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 600;
  border-radius: 10px;
  border: 2px solid var(--border);
  background: var(--surface);
  color: var(--text-dark);
  transition: all 0.3s ease;
  font-family: 'Zain', sans-serif;
}

.otp-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(45, 156, 219, 0.1);
}

body.dark-mode .otp-input {
  background: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}

.continue-button {
  padding: 1rem 2.5rem;
  background: linear-gradient(135deg, var(--primary-color), #1e7fa3);
  color: white;
  font-size: 1.1rem;
  font-weight: 700;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  width: 100%;
  max-width: 250px;
  box-shadow: 0 4px 12px rgba(45, 156, 219, 0.25);
}

.continue-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(45, 156, 219, 0.35);
}

.continue-button:active {
  transform: translateY(0);
}

body.dark-mode .continue-button {
  background: linear-gradient(135deg, #0f172a, #1a2f4a);
  border: 1px solid #334155;
}

body.dark-mode .continue-button:hover {
  border-color: #60a5fa;
}

/* ================ UTILITY CLASSES ================ */
.loading-text {
  text-align: center;
  font-size: 1.2rem;
  margin-top: 50px;
  color: var(--text-light);
}

.product-count {
  color: #e72424;
  font-size: 1.8rem;
  text-align: left;
  margin: 16px 0;
}

.banner-warning {
  color: orange;
  font-size: 0.85rem;
  margin-top: 1px;
}

.toast-success {
  background-color: #00C851 !important;
  color: white;
}

.toast-error {
  background-color: #ff4444 !important;
  color: white;
}

/* ================ CHECKOUT STYLES ================ */
.otp-verification-container {
    max-width: 550px;
    height: 400px;
    margin: 4rem auto;
    padding: 2rem;
    text-align: center;
    border-radius: 8px;
    border: 1px solid #979cdb;
    background-color: #ffffff;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.otp-title {
    font-family: 'Tajawal', sans-serif;
    margin-bottom: 1.5rem;
    color: #333;
    font-size: 1.5rem;
}

.phone-input-container {
    display: flex;
    gap: 10px;
    margin-bottom: 2rem;
    width: 100%;
}

.country-select {
    padding: 0.75rem;
    font-size: 1rem;
    border: 1px solid #ddd;
    border-radius: 20px;
    background-color: white;
}

.phone-input {
    flex: 1 1;
    padding: 0.75rem;
    font-size: 1rem;
    border: 1px solid #ddd;
    border-radius: 20px;
}

.otp-instructions {
    margin-bottom: 1.5rem;
    color: #555;
    font-size: 1.1rem;
}

.otp-inputs-container {
    display: flex;
    gap: 0.75rem;
    justify-content: center;
    margin-bottom: 2rem;
}

.otp-input {
    width: 3rem;
    height: 3rem;
    text-align: center;
    font-size: 1.5rem;
    border-radius: 6px;
    border: 1px solid #ddd;
}

.continue-button {
    padding: 0.75rem 2rem;
    background-color: #007b5e;
    color: white;
    font-size: 1rem;
    border: none;
    border-radius: 20px;
    cursor: pointer;
    transition: background-color 0.3s;
    width: 100%;
    max-width: 200px;
}

.continue-button:hover {
    transform: scale(1.10);
    color: aqua;
}

/* Checkout Form Styles */
.checkout-title {
    text-align: center;
    margin-bottom: 2rem;
    color: var(--secondary-color);
    font-size: 1.8rem;
    font-weight: 700;
}

body.dark-mode .checkout-title {
    color: #e2e8f0;
}

.customer-info-section {
    margin-bottom: 2rem;
    width: 100%;
    padding: 1.75rem;
    background: linear-gradient(135deg, #ffffff 0%, #f9fafc 100%);
    border-radius: 14px;
    border: 1px solid var(--border);
}

body.dark-mode .customer-info-section {
    background: linear-gradient(135deg, #1e293b 0%, #1a2536 100%);
    border-color: #334155;
}

/* Payment Method Styles */
.payment-method-section {
    margin-bottom: 2rem;
    padding: 1.75rem;
    background: linear-gradient(135deg, #ffffff 0%, #f9fafc 100%);
    border-radius: 14px;
    border: 1px solid var(--border);
}

body.dark-mode .payment-method-section {
    background: linear-gradient(135deg, #1e293b 0%, #1a2536 100%);
    border-color: #334155;
}

.location-selectors {
    display: flex;
    gap: 1.5rem;
    margin-bottom: 1rem;
    width: 100%;
    flex-wrap: wrap;
}

/* Payment Method Styles */
.payment-method-section {
    margin-bottom: 2rem;
    padding: 1.75rem;
    background: linear-gradient(135deg, #ffffff 0%, #f9fafc 100%);
    border-radius: 14px;
    border: 1px solid var(--border);
}

body.dark-mode .payment-method-section {
    background: linear-gradient(135deg, #1e293b 0%, #1a2536 100%);
    border-color: #334155;
}

.payment-selector {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    flex-wrap: wrap;
}

.payment-title {
    font-weight: 600;
    margin: 0;
    white-space: nowrap;
    color: var(--text-dark);
    font-size: 1.05rem;
}

body.dark-mode .payment-title {
    color: #e2e8f0;
}

.payment-type-select {
    padding: 0.875rem 1.5rem;
    border-radius: 10px;
    border: 2px solid var(--primary-color);
    min-width: 200px;
    font-size: 1rem;
    background: var(--surface);
    color: var(--text-dark);
    font-family: 'Zain', sans-serif;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 500;
}

.payment-type-select:hover {
    border-color: var(--primary-hover);
    box-shadow: 0 4px 12px rgba(45, 156, 219, 0.15);
}

body.dark-mode .payment-type-select {
    background: #1e293b;
    border-color: #60a5fa;
    color: #e2e8f0;
}

.cash-icon {
    color: var(--success);
    font-size: 2rem;
}

/* Order Items Styles */
.order-items-list {
    list-style: none;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 1.75rem;
    margin-bottom: 2rem;
}

.order-item-card {
    border: 1px solid var(--border);
    border-radius: 14px;
    padding: 1.25rem;
    background: linear-gradient(135deg, #ffffff 0%, #f9fafc 100%);
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
    text-align: center;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.order-item-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 24px rgba(45, 156, 219, 0.15);
    border-color: var(--primary-color);
}

body.dark-mode .order-item-card {
    background: linear-gradient(135deg, #1e293b 0%, #1a2536 100%);
    border-color: #334155;
}

.order-item-image {
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-radius: 10px;
    margin-bottom: 1rem;
    background: var(--surface-soft);
    border: 1px solid var(--border);
}

.order-item-details {
    font-size: 1rem;
    color: var(--text-dark);
    margin-bottom: 0.75rem;
}

body.dark-mode .order-item-details {
    color: #e2e8f0;
}

.order-item-price {
    font-weight: 700;
    color: var(--primary-color);
    font-size: 1.2rem;
}

body.dark-mode .order-item-price {
    color: #60a5fa;
}

/* Order Summary Styles */
.order-summary {
    text-align: center;
    margin-top: 2rem;
    padding: 2rem;
    background: linear-gradient(135deg, var(--primary-color), #1e7fa3);
    border-radius: 14px;
    color: white;
    box-shadow: 0 8px 24px rgba(45, 156, 219, 0.2);
}

body.dark-mode .order-summary {
    background: linear-gradient(135deg, #0f172a, #1a2f4a);
    border: 1px solid #334155;
}

.order-total {
    margin-top: 1.5rem;
    font-size: 1.8rem;
    font-weight: 800;
    color: white;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.place-order-button {
    margin-top: 1.5rem;
    padding: 1rem 2.5rem;
    font-size: 1.1rem;
    font-weight: 700;
    background: white;
    color: var(--primary-color);
    border: none;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    width: 100%;
    max-width: 300px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.place-order-button:hover {
    background: #f0f9ff;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

.place-order-button:active {
    transform: translateY(0);
}

body.dark-mode .place-order-button {
    background: #e2e8f0;
    color: #0f172a !important;
}

body.dark-mode .place-order-button:hover {
    background: #f0f9ff;
}

.empty-order-message {
    text-align: center;
    color: var(--text-muted);
    font-size: 1.2rem;
    margin: 2rem 0;
    padding: 2rem;
}

body.dark-mode .empty-order-message {
    color: #94a3b8;
}

.responsive-table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.orders-history-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 800px; /* Ensures all columns fit side-by-side */
}

.orders-history-table th,
.orders-history-table td {
  padding: 0.75rem;
  text-align: center;
  border: 1px solid #ddd;
}


/* ================ MEDIA QUERIES ================ */

@media screen and (max-width: 768px) {

   .mobile-only {
    display: block;
  }
  /* .desktop-only {
    display: none;
  } */

  .navbar-container {
    flex-direction: row; 
    justify-content: space-between;
  }

   .nav-title {
    font-size: 1rem;
  }

  .nav-left {
    order: 1; 
    flex: 1 1;
    justify-content: flex-start;
  }

  .nav-right {
    order: 2; 
    flex: 1 1;
    justify-content: flex-end;
    gap: 10px;
  }

  .nav-link {
    font-size: 0.9rem;
    padding: 5px;
  }

  /* Ensure home link is positioned correctly */
  .nav-link:first-child {
    margin-right: auto; /* Pushes other links to the right */
  }

   .banner-wrapper {
    margin: 0 auto !important;
    padding: 0 !important;
  }
  
  .animated-banner {
    margin: 2px auto; /* Very small vertical margin */
  }
  
    .product-grid {
    margin-top: 2px; /* Minimal space below banner */
    padding: 0.9rem; /* Reduced grid padding */
  }
  
  .banner-image {
    width: 100%;
    height: auto;
    display: block;
  }
  
   .page-center {
    min-height: unset !important;
    padding: 0.5rem !important;
    display: block !important;
  }


}

@media (max-width: 600px) {
  .location-selectors {
    flex-wrap: nowrap;
    width: 100%; /* Optional: full width on mobile */
    overflow-x: auto; /* Optional: horizontal scroll if needed */
  }

  .location-selectors select {
    flex: 1 1; /* Allow flexible sizing */
    min-width: 0;
  }
}


/* Very small screens */
@media screen and (max-width: 480px) {
  .navbar-container {
    flex-direction: row; 
    justify-content: space-between;
  }

  .nav-right {
    gap: 5px;
  }

  .nav-title {
    font-size: 0.9rem;
  }

  .nav-link {
    font-size: 0.8rem;
  }

  

.animated-banner {
    max-width: 95%;
  }
  
  .banner-fallback {
    height: 120px;
    font-size: 0.9rem;
  } 
  
  .otp-input {
        width: 2rem;
        height: 2rem;
        font-size: 1.2rem;
    }
    
    .order-items-list {
        grid-template-columns: 1fr;
    }
    
    .order-item-image {
        height: 150px;
    }
}

  /* Product Grid */
@media (max-width: 768px) {  

  .nav-phone {
        font-size: 0.9rem;
        color: #9ad12d;
    }

    .nav-cart {
        font-size: 1rem;
        color: white;
    }

    .hamburger-wrapper {
    display: flex;
    align-items: center;
    margin: 0;
  }

   .desktop-only {
    display: none;
  }

    .nav-logo {
    padding-right: 0;
    margin-right: 0;
    width: 60px;
  }

  .nav-left {
    /* display: flex;
    align-items: center;
    gap: 0px; space between hamburger and logo */
    display: flex;
  align-items: center;
  gap: 0; /* Remove space between logo and hamburger */
  flex-wrap: nowrap; /* Prevent wrapping */
  overflow: hidden;

  }

  .product-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 1rem;
  }

  .product-card {
    padding: 12px;
  }

  .product-image {
    height: 120px;
  }

  .product-info h3 {
    font-size: 1rem;
  }

  .btn-add {
    width: 100%;
    padding: 8px 10px;
    font-size: 0.6rem;
  }
  .btn-add:hover {
  background-color: var(--primary-hover);
  color: aqua;
}

  /* Cart */
  .cart-container {
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .cart-header {
    width: 100%;
    justify-content: center;
    margin-bottom: 0.5rem;
  }

  .cart-header h2 {
    font-size: 1.5rem;
  }

  .cart-list {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.25rem;
    padding: 0;
    list-style: none;
    width: 100%;
  }

  .cart-card {
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    padding: 1.25rem;
    border-radius: 12px;
    gap: 1rem;
    align-items: stretch;
  }

  .cart-image-wrapper {
    height: 180px;
    width: 100%;
    order: -1;
  }

  .cart-item {
    display: flex;
    justify-content: center;
  }

  .cart-img {
    width: 100%;
    max-width: 100%;
    border-radius: 8px;
  }

  .cart-name,
  .cart-price,
  .cart-controls,
  .btn-remove {
    margin: 0;
    padding: 5px;
    border-radius: 8px;
    width: 100%;
  }

  .cart-controls button {
    font-size: 20px;
  }

  .cart-summary {
    width: 100%;
    margin-top: 1.5rem;
  }

  .btn-checkout {
    width: 100%;
    min-width: auto;
    padding: 0.75rem 1rem;
    font-size: 1rem;
  }

  /* Checkout Responsive */
  .checkout-container {
    padding: 1.5rem;
    margin: 1rem auto;
  }

  .checkout-title {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .customer-info-section,
  .payment-method-section {
    padding: 1.25rem;
    margin-bottom: 1.5rem;
  }

  .location-selectors {
    flex-direction: column;
    gap: 1rem;
    width: 100%;
  }

  .state-select,
  .district-select {
    width: 100%;
    min-width: auto;
  }

  .order-items-list {
    grid-template-columns: 1fr;
  }

  .order-item-card {
    padding: 1rem;
  }

  .order-item-image {
    height: 150px;
  }

  .otp-verification-container {
    padding: 1.5rem;
    margin: 2rem 1rem;
  }

  .otp-inputs-container {
    gap: 0.5rem;
  }

  .otp-input {
    width: 2.75rem;
    height: 2.75rem;
    font-size: 1.2rem;
  }

  .continue-button {
    padding: 0.875rem 1.5rem;
    font-size: 1rem;
    max-width: 100%;
  }

  .phone-input-container {
    flex-direction: column;
    gap: 0.75rem;
  }

  .country-select,
  .phone-input {
    width: 100%;
  }

  .place-order-button {
    max-width: 100%;
    padding: 0.875rem 1rem;
  }
  
}

@media (max-width: 480px) {
  .product-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .product-info h3 {
    font-size: 0.9rem;
  }

  .footer-container {
    flex-direction: column;
    gap: 15px;
  }
}

/* Base style adjustments for mobile */
@media (max-width: 767px) {
  .product-card-details {
    max-width: 90%;
    margin: 20px auto;
    padding: 16px;
  }

  .product-card-details {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .image-section {
    order: -1; /* Move image to top if needed */
    text-align: center;
    width: 100%;
  }

  .details-image {
    max-width: 100%;
    height: auto;
    margin: 0 auto;
  }

  .info-section {
    padding: 10px 0;
  }
}

@media (min-width: 768px) {
  .product-details {
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
  }

  .details-info {
    text-align: center;
  }

  .cart-content {
    display: flex;
    flex-direction: column;
    align-items: center;    
    text-align: center;     
    margin-right: 16px;     
  }

  .cart-content > * {
  margin-bottom: 10px;
}
  
}

/* ================ GO BACK BUTTON ================ */
.go-back-button {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-hover) 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 4px 12px rgba(45, 156, 219, 0.3);
}

.go-back-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(45, 156, 219, 0.4);
  background: linear-gradient(135deg, var(--primary-hover) 0%, #1568b8 100%);
}

.go-back-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(45, 156, 219, 0.3);
}

body.dark-mode .go-back-button {
  background: linear-gradient(135deg, #4a9eff 0%, #2a7acc 100%);
  box-shadow: 0 4px 12px rgba(74, 158, 255, 0.3);
}

body.dark-mode .go-back-button:hover {
  box-shadow: 0 6px 16px rgba(74, 158, 255, 0.4);
  background: linear-gradient(135deg, #2a7acc 0%, #1a5a9f 100%);
}

@media (max-width: 480px) {
  .go-back-button {
    padding: 0.6rem 1.2rem;
    font-size: 0.9rem;
  }
}

/* ================ ANIMATIONS ================ */
.fade-in {
  animation: fadeIn 0.5s ease-in;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.shimmer::after {
  content: '';
  position: absolute;
  top: 0;
  left: -150%;
  height: 100%;
  width: 150%;
  background: linear-gradient(to right, transparent 0%, rgba(255,255,255,0.1) 50%, transparent 100%);
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% { left: -150%; }
  100% { left: 100%; }
}

/* ================ VARIANT PICKER ================ */
.variant-picker {
  margin: 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  width: 100%;
}

.variant-attribute {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  align-items: center;
}

.variant-attribute-label {
  font-weight: 700;
  color: var(--text-dark);
  font-size: 0.95rem;
}

body.dark-mode .variant-attribute-label {
  color: #e2e8f0;
}

.variant-options {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  justify-content: center;
}

.variant-option {
  padding: 0.5rem 1.15rem;
  border-radius: 20px;
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--text-dark);
  cursor: pointer;
  font-size: 0.9rem;
  font-family: 'Zain', sans-serif;
  transition: all 0.2s ease;
}

.variant-option:hover:not(.variant-option-disabled):not(.variant-option-selected) {
  border-color: var(--primary-color);
  color: var(--primary-color);
  transform: translateY(-1px);
}

.variant-option-selected {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: #fff;
  font-weight: 700;
}

.variant-option-selected:hover {
  background: var(--primary-hover);
  border-color: var(--primary-hover);
  transform: translateY(-1px);
}

.variant-option-disabled {
  opacity: 0.4;
  cursor: not-allowed;
  text-decoration: line-through;
}

body.dark-mode .variant-option {
  background: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}

body.dark-mode .variant-option:hover:not(.variant-option-disabled):not(.variant-option-selected) {
  border-color: #60a5fa;
  color: #60a5fa;
}

body.dark-mode .variant-option-selected {
  background: #2d9cdb;
  border-color: #2d9cdb;
  color: #fff;
}

body.dark-mode .variant-option-disabled {
  opacity: 0.35;
}

/* Disabled add-to-cart state (used while a variant product has no full
   selection yet) */
.add-to-cart-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.add-to-cart-btn:disabled:hover {
  background-color: var(--surface);
  color: inherit;
  transform: none;
}

.btn-add:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-add:disabled:hover {
  background-color: var(--pure-white, #fff);
  color: inherit;
}

/* ================ CART LINE VARIANT TEXT ================ */
.cart-variant-text {
  font-size: 0.85rem;
  color: var(--text-muted);
  margin: 0;
  text-align: right;
}

body.dark-mode .cart-variant-text {
  color: #94a3b8;
}

/* ================ STOCK TEXT ================ */
.stock-text {
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0.5rem 0 0 0;
}

.stock-available {
  color: var(--success);
}

.stock-out {
  color: var(--danger);
}

body.dark-mode .stock-available {
  color: #4ade80;
}

body.dark-mode .stock-out {
  color: #f87171;
}

@media (max-width: 480px) {
  .variant-option {
    padding: 0.45rem 0.9rem;
    font-size: 0.85rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;EACE,wBAAwB;EACxB,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,iCAAiC;EACjC,sCAAsC;EACtC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;;;;;;;;;;;;;;;EAgBE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;;;EAGE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,SAAO;AACT;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,SAAO;EACP,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,cAAc;AAChB;;;AAGA,6CAA6C;;AAE7C;EACE,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,mBAAmB;EAEnB,gBAAgB;EAChB,WAAW;EACX,MAAM;EACN,aAAa;EACb,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;;;AAIA,sBAAsB;AACtB;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,mBAAmB;AACnB,uCAAuC;AACvC;EACE,gBAAgB;EAEhB,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAEhB,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,SAAO;IACP,yBAAyB;AAC7B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,WAAW;EACX,yBAAyB,GAAG,+BAA+B,GAAG,oBAAoB;EAClF,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc,CAAC;;AAEnB;GACG,kBAAkB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;IACI,mBAAmB;EACrB,0BAA0B,EAAE,2BAA2B;EACvD,qBAAqB,EAAE,uBAAuB;EAC9C,eAAe;EACf,gBAAgB;EAChB,uBAAuB,EAAE,6BAA6B;AACxD;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;;AAGA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;MAClB,eAAe;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;;AAGA;EACE,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA;EACE,aAAa;AACf;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,6CAA6C;EAC7C,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;IAEI,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,mDAAmD;AACnD;;;;;;GAMG;;AAEH;EACE,iBAAiB;EACjB,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,8CAA8C;EAC9C,kBAAkB;EAClB,qDAAqD;EACrD,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;;AAGA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,WAAW;AACb;;;;AAIA;EACE,sBAAsB;AACxB;;AAEA;EACE,iFAAiF;EACjF,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;AAC5C;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;GACrB,WAAW;AACd;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA,sDAAsD;AACtD;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,2CAA2C;AAC3C;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kEAAkE;EAClE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,2CAA2C;EAC3C,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oEAAoE;EACpE,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iDAAiD;EACjD,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6EAA6E;EAC7E,oBAAoB;EACpB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;AACnB;;;AAGA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,kEAAkE;EAClE,mBAAmB;EACnB,YAAY;EACZ,8CAA8C;EAC9C,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,6CAA6C;;AAE7C;EACE,UAAU;EACV,cAAc;EACd,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO,EAAE,uBAAuB;AAClC;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,WAAW;EACX,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,+CAA+C;AAC/C;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,oEAAoE;EACpE,mBAAmB;EACnB,8CAA8C;EAC9C,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,oDAAoD;AACpD;;EAEE,gBAAgB;EAChB,6DAA6D;EAC7D,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;;EAEE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;EACvB,+BAA+B;EAC/B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,6DAA6D;EAC7D,4CAA4C;EAC5C,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kEAAkE;EAClE,mBAAmB;EACnB,YAAY;EACZ,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,oEAAoE;EACpE,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;EACvB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kEAAkE;EAClE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iDAAiD;EACjD,WAAW;EACX,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA,sDAAsD;AACtD;IACI,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,sCAAsC;AAC1C;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;IACrB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,iCAAiC;IACjC,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,6DAA6D;IAC7D,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;AACzB;;AAEA,0BAA0B;AAC1B;IACI,mBAAmB;IACnB,gBAAgB;IAChB,6DAA6D;IAC7D,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA,0BAA0B;AAC1B;IACI,mBAAmB;IACnB,gBAAgB;IAChB,6DAA6D;IAC7D,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,sCAAsC;IACtC,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,uBAAuB;IACvB,+BAA+B;IAC/B,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA,uBAAuB;AACvB;IACI,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,4DAA4D;IAC5D,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;IAChB,6DAA6D;IAC7D,4CAA4C;IAC5C,kBAAkB;IAClB,iDAAiD;AACrD;;AAEA;IACI,2BAA2B;IAC3B,gDAAgD;IAChD,kCAAkC;AACtC;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,kEAAkE;IAClE,mBAAmB;IACnB,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,qDAAqD;IACrD,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;IAC3B,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,iDAAiD;IACjD,WAAW;IACX,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;IACjB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB,EAAE,yCAAyC;AAC7D;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;;AAGA,oDAAoD;;AAEpD;;GAEG;IACC,cAAc;EAChB;EACA;;KAEG;;EAEH;IACE,mBAAmB;IACnB,8BAA8B;EAChC;;GAEC;IACC,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,SAAO;IACP,2BAA2B;EAC7B;;EAEA;IACE,QAAQ;IACR,SAAO;IACP,yBAAyB;IACzB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA,6CAA6C;EAC7C;IACE,kBAAkB,EAAE,oCAAoC;EAC1D;;GAEC;IACC,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,gBAAgB,EAAE,+BAA+B;EACnD;;IAEE;IACA,eAAe,EAAE,+BAA+B;IAChD,eAAe,EAAE,yBAAyB;EAC5C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;GAEC;IACC,4BAA4B;IAC5B,0BAA0B;IAC1B,yBAAyB;EAC3B;;;AAGF;;AAEA;EACE;IACE,iBAAiB;IACjB,WAAW,EAAE,mCAAmC;IAChD,gBAAgB,EAAE,0CAA0C;EAC9D;;EAEA;IACE,SAAW,EAAE,0BAA0B;IACvC,YAAY;EACd;AACF;;;AAGA,uBAAuB;AACvB;EACE;IACE,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;;;AAIF;IACI,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;QACM,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;AACJ;;EAEE,iBAAiB;AACnB;;EAEE;QACM,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;IACA,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;GAEC;IACC,aAAa;EACf;;IAEE;IACA,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;;EAEA;IACE;;gDAE4C;IAC5C,aAAa;EACf,mBAAmB;EACnB,MAAM,EAAE,4CAA4C;EACpD,iBAAiB,EAAE,qBAAqB;EACxC,gBAAgB;;EAEhB;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,iBAAiB;EACnB;EACA;EACA,sCAAsC;EACtC,WAAW;AACb;;EAEE,SAAS;EACT;IACE,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,SAAS;EACX;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;;EAEA;;;;IAIE,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,eAAe;EACjB;;EAEA,wBAAwB;EACxB;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;;IAEE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;;AAEF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,cAAc;IACd,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,SAAS,EAAE,gCAAgC;IAC3C,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;EACA,mBAAmB;AACrB;;AAEA;;AAEA,qDAAqD;AACrD;EACE,uFAAuF;EACvF,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,0EAA0E;AAC5E;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;EAC9C,6DAA6D;AAC/D;;AAEA;EACE;IACE,sBAAsB;IACtB,iBAAiB;EACnB;AACF;;AAEA,iDAAiD;AACjD;EACE,8BAA8B;AAChC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kGAAkG;EAClG,gCAAgC;AAClC;;AAEA;EACE,KAAK,WAAW,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB;;AAEA,qDAAqD;AACrD;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;mBACmB;AACnB;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;IACvB,kBAAkB;EACpB;AACF","sourcesContent":["/* ================ BASE STYLES ================ */\n:root {\n  --primary-color: #2d9cdb;\n  --primary-hover: #1b82c6;\n  --secondary-color: #0e1940;\n  --secondary-hover: #132451;\n  --accent-color: #f7b731;\n  --accent-contrast: #111;\n  --text-light: #eef2ff;\n  --text-dark: #111827;\n  --text-muted: #64748b;\n  --bg: #f7f9fc;\n  --surface: #ffffff;\n  --surface-soft: #f3f6ff;\n  --border: #d1d7e2;\n  --shadow: rgba(23, 71, 132, 0.12);\n  --card-shadow: rgba(23, 71, 132, 0.08);\n  --danger: #ef4444;\n  --success: #22c55e;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  height: 100%;\n  margin: 0;\n  font-family: 'Zain', sans-serif;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  background-color: var(--bg);\n  color: var(--text-dark);\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n#root {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\nbody.dark-mode {\n  background-color: #0f172a !important;\n  color: #e2e8f0;\n}\n\nbody.dark-mode .navbar {\n  background: #1e293b;\n  border-bottom: 1px solid #334155;\n}\n\nbody.dark-mode .navbar-container a,\nbody.dark-mode .nav-title,\nbody.dark-mode .nav-cart,\nbody.dark-mode .phone-text,\nbody.dark-mode .dropdown-menu a,\nbody.dark-mode .dropdown-menu button,\nbody.dark-mode .product-description,\nbody.dark-mode .product-name,\nbody.dark-mode .add-to-cart-btn,\nbody.dark-mode .product-info h3,\nbody.dark-mode .product-info p,\nbody.dark-mode button,\nbody.dark-mode .item-total,\nbody.dark-mode .item-tot-price-number\n\n{\n  color: #dbeafe !important;\n}\n\nbody.dark-mode .footer-text,\nbody.dark-mode .footer-brand {\n  color: #cbd5e1 !important;\n}\n\nbody.dark-mode .product-card,\nbody.dark-mode .cart-card,\nbody.dark-mode .checkout-container,\nbody.dark-mode .product-card-details,\nbody.dark-mode .banner-fallback,\nbody.dark-mode .basket-summary,\nbody.dark-mode .cart-summary {\n  background: #1e293b;\n  border-color: #334155;\n}\n\nbody.dark-mode .footer {\n  background: #0f172a;\n  border-top: 1px solid #334155;\n}\n\nbody.dark-mode .product-image,\nbody.dark-mode .cart-img,\nbody.dark-mode .banner-image {\n  filter: brightness(0.9);\n  -webkit-filter: brightness(0.9);\n}\n\n.main-wrapper {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  flex: 1;\n}\n.nav-title {\n  color: #1e293b !important;\n  font-size: 1.1rem;\n  font-weight: bold;\n  white-space: nowrap;\n}\n\n.shop-shell-wrapper {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  flex: 1;\n  background: var(--bg);\n}\nbody.dark-mode .shop-shell-wrapper {\n  background: #0f172a;\n}\n\n.shop-shell-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n}\n\n.page-center {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n}\n\n.product-list {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ================ LAYOUT COMPONENTS ================ */\n.container {\n  width: 100%;\n  margin: 0 auto;\n}\n\n\n/* ================ NAVBAR ================ */\n\n.navbar {\n  background: #f0f4f9;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  position: -webkit-sticky;\n  position: sticky;\n  width: 100%;\n  top: 0;\n  z-index: 1000;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.navbar-container {\n  max-width: 1800px;\n  margin: 0 auto;\n  padding: 0 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 72px;\n  width: 100%;\n  color: var(--text-light);\n}\n\n.nav-left {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  flex: 1;\n}\n\n.nav-logo {\n  height: 50px;\n  width: auto;\n  object-fit: contain;\n  padding-right: 30px;\n}\n\n\n\n/* Shimmer Animation */\n.nav-center {\n  flex: 1;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: #212831 solid 1px;\n  background-color: #eeeeee;\n  padding: 10px 20px;\n  border-radius: 15%;\n  position: relative;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  -webkit-border-radius: 15%;\n  -moz-border-radius: 15%;\n  -ms-border-radius: 15%;\n  -o-border-radius: 15%;\n}\n\n@media (max-width: 900px) {\n  .nav-center {\n    display: none;\n  }\n}\n\n.nav-title {\n  color: #1e293b;\n  font-size: 1.1rem;\n  font-weight: bold;\n  white-space: nowrap;\n  position: relative;\n  z-index: 1;\n}\n\n/* Shimmer Effect */\n/* Simplified name text: no animation */\n.shimmer-text {\n  background: none;\n  -webkit-background-clip: unset;\n  background-clip: unset;\n  color: inherit;\n  animation: none;\n}\n\nbody.dark-mode .nav-center {\n  border-color: #475569;\n  background: rgba(255, 255, 255, 0.05);\n}\n\nbody.dark-mode .shimmer-text {\n  background: none;\n  -webkit-background-clip: unset;\n  background-clip: unset;\n  color: inherit;\n  animation: none;\n}\n\n.nav-right {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    font-size: 1rem;\n    flex: 1;\n    justify-content: flex-end;\n}\n\n.dark-mode-toggle {\n  border: 1px solid #cbd5e1;\n  background: rgba(0, 0, 0, 0.05);\n  color: #1e293b;\n  border-radius: 999px;\n  padding: 0.8rem 1rem;\n  cursor: pointer;\n  font-size: 0.95rem;\n  transition: transform 0.2s ease, background 0.2s ease;\n}\n\n.dark-mode-toggle:hover {\n  transform: translateY(-1px);\n  background: rgba(0, 0, 0, 0.1);\n}\n\n/* Theme Buttons Group */\n.theme-buttons-group {\n  display: flex;\n  gap: 0.5rem;\n  border: 1px solid #cbd5e1;  background: rgba(0, 0, 0, 0.05);  border-radius: 999px;\n  padding: 0.3rem;\n}\n\n.theme-btn {\n  background: transparent;\n  border: none;\n  color: #1e293b;\n  padding: 0.2rem 0.3rem;\n  cursor: pointer;\n  font-size: 1rem;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.theme-btn:hover {\n  background: rgba(0, 0, 0, 0.08);\n  transform: translateY(-1px);\n}\n\n.theme-btn.active {\n  background: rgba(0, 0, 0, 0.15);\n  box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.1);\n}\n\nbody.dark-mode .theme-btn {\n  color: #dbeafe;\n}\n\nbody.dark-mode .theme-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\nbody.dark-mode .theme-btn.active {\n  background: rgba(255, 255, 255, 0.2);\n}\n\nbody.dark-mode .nav-cart {\n  color: #dbeafe;\n}\n\nbody.dark-mode .nav-cart:hover {\n  color: #93c5fd;\n}\n\nbody.dark-mode .phone-button {\n  color: #dbeafe;\n}\n\nbody.dark-mode .phone-button:hover {\n  color: #93c5fd;\n}\n\nbody.dark-mode .desktop-only a {\n  color: #dbeafe;\n}\n\nbody.dark-mode .hamburger-button span {\n  background: #dbeafe;\n}\n\nbody.dark-mode .theme-buttons-group {\n  border-color: #475569;\n  background: rgba(255, 255, 255, 0.05);\n}\n\nbody.dark-mode .dark-mode-toggle {\n  border-color: #475569;\n  background: rgba(255, 255, 255, 0.05);\n  color: #dbeafe;\n}\n\nbody.dark-mode .dark-mode-toggle:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.nav-cart {\n  font-size: 1.5rem;\n  color: #0c131f;\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n.cart-count {\n  color: #2b5ba7;\n}\n\nbody.dark-mode .cart-count {\n  color: #93c5fd;\n}\n\n.nav-cart:hover {\n  color: #2d9cdb;\n}\n\n.nav-logo {\n  height: 50px;\n  width: auto;\n  object-fit: contain;\n  padding-right: 30px;\n}\n\n\n\n.nav-right {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    font-size: 1rem;\n}\n\n.nav-phone {\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    font-size: 0.95rem;\n    color: #9ad12d;\n}\n\n.phone-text {\n    margin-left: 0.3rem;\n    color: #1e293b;}\n\n.dropdown-wrapper {\n   position: relative;\n}   \n\n.phone-button {\n  background: none;\n  border: none;\n  color: #1e293b;\n  cursor: pointer;\n  font-size: 1rem;\n  font-family: inherit;\n  transition: color 0.2s ease;\n}\n\n.phone-button:hover {\n  color: #2d9cdb;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background-color: #333;\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  min-width: 160px;\n  z-index: 1000;\n  border-radius: 6px;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.15);\n}\n\n.dropdown-link {\n    white-space: nowrap;\n  font-size: 18px !important; /* or your preferred size */\n  display: inline-block; /* or block if needed */\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis; /* optional, for long items */\n}\n\na.dropdown-link {\n  font-size: 15px !important;\n  color: #333;\n  padding: 8px 12px;\n  display: block;\n  text-decoration: none;\n}\n\n\n.dropdown-menu a,\n.dropdown-menu button {\n  color: white;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  padding: 0.5rem 1rem;\n  text-decoration: none;\n  font-size: 0.95rem;\n}\n\n.dropdown-menu a:hover,\n.dropdown-menu button:hover {\n  background-color: #444;\n      font-size: 16px;\n}\n\n.dropdown-link:hover {\n  background-color: #f0f0f0;\n  color: #000;\n  cursor: pointer;\n}\n\n\n.nav-cart {\n  font-size: 1.5rem;\n  color: white;\n  text-shadow: 1px 1px 2px #000;\n  display: flex;\n  align-items: center;\n}\n\n.nav-center {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  text-align: center;\n}\n\n.nav-title {\n  color: #ccc;\n  font-size: 1.1rem;\n  font-weight: bold;\n  white-space: nowrap;\n}\n\n.nav-link {\n  color: #ccc;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n/* Hide mobile hamburger on desktop */\n.mobile-only {\n  display: none;\n}\n\n/* Show full menu on desktop */\n.desktop-only {\n  display: flex;\n  gap: 1px;\n  align-items: center;\n}\n\n.desktop-only a {\n  color: #1e293b;           \n  font-size: 1.6rem;        \n  text-decoration: none;   \n  padding-right: 50px;\n  transition: color 0.2s ease;\n}\n\n.desktop-only a:hover {\n  color: var(--primary-color); \n}\n\n\n.hamburger-wrapper {\n  display: none;\n}\n\n.hamburger-menu {\n    position: relative;\n    display: inline-block;\n}\n\n.hamburger-button {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    width: 2rem;\n    height: 2rem;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 0;\n    margin-left: 1rem;\n}\n\n.hamburger-button span {\n    width: 25px;\n    height: 3px;\n    background: #1e293b;\n    border-radius: 10px;\n    transition: all 0.3s linear;\n    position: relative;\n    transform-origin: 1px;\n}\n\n.hamburger-button.open span:first-child {\n    transform: rotate(45deg);\n}\n\n.hamburger-button.open span:nth-child(2) {\n    opacity: 0;\n}\n\n.hamburger-button.open span:last-child {\n    transform: rotate(-45deg);\n}\n\n\n.hamburger-dropdown {\n  position: absolute;\n  top: 40px;\n  left: 0;\n  background: rgb(245, 222, 222);\n  border: 1px solid #3b6747;\n  padding: 10px;\n  border-radius: 6px;\n  box-shadow: 0px 4px 18px rgba(220, 4, 4, 0.1);\n  z-index: 999;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.hamburger-dropdown a, \n.hamburger-dropdown button {\n    padding: 1.5rem;\n    text-decoration: none;\n    color: #de6767;\n    text-align: right;\n    background: none;\n    border: none;\n    cursor: pointer;\n}\n\n.hamburger-dropdown button {\n    text-align: right;\n}\n\n/* ================ PRODUCT GRID ================ */\n/* .product-grid {\n  margin-top: 5px;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 1.5rem;\n  padding: 1rem;\n} */\n\n.product-grid {\n  margin: 25px auto;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 2rem;\n  padding: 0 1rem;\n  max-width: 1200px;\n  width: 100%;\n}\n\n.product-card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 22px 50px rgba(15, 23, 42, 0.14);\n}\n\n.product-card {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 18px;\n  padding: 16px;\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);\n  text-align: center;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  direction: rtl;\n}\n\n.product-image {\n  width: 100%;\n  height: 200px;\n  object-fit:fill;\n  margin-bottom: 10px;\n  border-radius: 4px;\n  padding: 10px;\n}\n\n.product-info {\n  padding: 15px 0;\n  text-align: center;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.product-info h3 {\n  font-size: 1.1rem;\n  margin-bottom: 8px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n.product-info p {\n  font-weight: bold;\n  margin-bottom: 12px;\n  color: var(--text-dark);\n}\n\n.product-card {\n  background: var(--pure-white);\n  border: 1px solid #979cdb;\n  border-radius: 8px;\n  padding: 2px;\n  box-shadow: 0 0 10px rgba(0,0,0,0.1);\n  text-align: center;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  direction: rtl;\n}\n\n\n.product-card-details {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 16px;\n  margin: 30px auto;\n  max-width: 600px;\n  border: 1px solid #979cdb;\n  border-radius: 12px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);\n  background-color: #fff;\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n\n\n.product-details {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 10px;\n  gap: 20px;\n}\n\n\n.details-image {\n  width: 500px;\n  height: 300px;\n  object-fit: contain;\n}\n\n.details-info {\n  text-align: center;\n  max-width: 600px;\n}\n\n/* ================ BUTTONS ================ */\n.btn {\n  border: 1px solid #242ec1;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s;\n  font-size: 0.9rem;\n}\n\n.add-to-cart-btn {\n  padding: 10px 20px;\n  background-color: var(--pure-white);\n  border: 1px solid #979cdb;\n  color: rgb(0, 0, 0);\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 16px;\n  margin-top: 15px;\n}\n\n.add-to-cart-btn:hover {\n  background-color: var(--primary-hover);\n  color: aqua;\n}\n\n\n\n.btn-remove:hover {\n  transform: scale(1.05);\n}\n\n.btn-checkout {\n  background: linear-gradient(to right, var(--primary-color), var(--primary-hover)); \n  color: white;\n  padding: 12px 24px;\n  border-radius: 20px;\n  font-size: 1rem;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n}\nbody.dark-mode .btn-checkout {\n  color: #000 !important;\n}\n\n.btn-checkout:hover {\n  transform: scale(1.10);\n   color: aqua;\n}\n\n.btn-add {\n    width: 50%;\n    padding: 8px 10px;\n    font-size: 0.6rem;\n}\n\n/* ================ CART ANIMATIONS ================ */\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* ================ CART ================ */\n.cart-container {\n  padding: 3rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2.5rem;\n  max-width: 1400px;\n  margin: 0 auto;\n  width: 100%;\n  min-height: 60vh;\n}\n\n.cart-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1.5rem;\n  position: relative;\n  margin-bottom: 1rem;\n}\n\n.cart-header h2 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--secondary-color);\n  margin: 0;\n  animation: slideInUp 0.6s ease-out;\n}\n\nbody.dark-mode .cart-header h2 {\n  color: #e2e8f0;\n}\n\n.cart-count-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  background: linear-gradient(135deg, var(--primary-color), #1e7fa3);\n  color: white;\n  border-radius: 50%;\n  font-weight: 700;\n  font-size: 1rem;\n  animation: slideInUp 0.6s ease-out 0.1s both;\n  box-shadow: 0 4px 12px rgba(45, 156, 219, 0.3);\n}\n\n.cart-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 1.75rem;\n  padding: 0;\n  list-style: none;\n  width: 100%;\n}\n\n.cart-item {\n  opacity: 0;\n  animation: slideInUp 0.5s ease-out forwards;\n  animation-delay: calc(var(--item-index) * 0.08s);\n}\n\n.cart-card {\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(135deg, var(--surface) 0%, #f8fafb 100%);\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  padding: 1.5rem;\n  gap: 1.25rem;\n  height: 100%;\n  position: relative;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);\n  overflow: hidden;\n}\n\n.cart-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, var(--primary-color), var(--accent-color));\n  transform: scaleX(0);\n  transform-origin: left;\n  transition: transform 0.4s ease;\n}\n\n.cart-card:hover::before {\n  transform: scaleX(1);\n}\n\n.cart-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 12px 24px rgba(45, 156, 219, 0.15);\n  border-color: var(--primary-color);\n}\n\nbody.dark-mode .cart-card {\n  background: linear-gradient(135deg, #1e293b 0%, #1a2536 100%);\n  border-color: #334155;\n}\n\n.cart-image-wrapper {\n  width: 100%;\n  height: 200px;\n  border-radius: 12px;\n  overflow: hidden;\n  background: var(--surface-soft);\n  border: 1px solid var(--border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cart-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.4s ease;\n}\n\n.cart-item:hover .cart-img {\n  transform: scale(1.08);\n}\n\n.cart-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.cart-name {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text-dark);\n  margin: 0;\n  line-height: 1.4;\n  text-align: right;\n}\n\nbody.dark-mode .cart-name {\n  color: #e2e8f0;\n}\n\n.cart-price {\n  font-size: 1.3rem;\n  color: var(--primary-color);\n  font-weight: 700;\n  margin: 0.5rem 0 0 0;\n}\n\nbody.dark-mode .cart-price {\n  color: #60a5fa;\n}\n\n.item-total {\n  font-size: 0.95rem;\n  color: var(--text-muted);\n  margin: 0.5rem 0 0 0;\n  text-align: right;\n}\n\n\n.item-total strong {\n  color: var(--primary-color);\n  font-weight: 700;\n}\n\n.cart-controls {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  margin-top: 0.75rem;\n  padding: 0.75rem;\n  background: var(--surface-soft);\n  border-radius: 10px;\n}\n\n.qty-btn {\n  padding: 0.5rem 0.875rem;\n  background: var(--primary-color);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n  min-width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.qty-btn:hover {\n  background: var(--primary-hover);\n  transform: scale(1.05);\n}\n\n.qty-btn:active {\n  transform: scale(0.95);\n}\n\n.qty-display {\n  min-width: 40px;\n  text-align: center;\n  font-weight: 600;\n  color: var(--text-dark);\n  font-size: 1rem;\n}\n\nbody.dark-mode .qty-display {\n  color: #080b0f;\n}\n\n.btn-remove {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n}\n\n.btn-icon {\n  font-size: 1.2rem;\n}\nbody.dark-mode .btn-icon {\n  color: #ef4444;\n}\n\n.btn-remove:hover {\n  background: rgba(239, 68, 68, 0.2);\n  transform: scale(1.1) rotate(10deg);\n}\n\n.btn-remove:active {\n  transform: scale(0.95);\n}\n\nbody.dark-mode .btn-remove {\n  background: rgba(239, 68, 68, 0.15);\n  color: #f87171;\n}\n\n.cart-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  align-items: center;\n  justify-content: center;\n  margin-top: 2rem;\n  padding: 2rem;\n  background: linear-gradient(135deg, var(--primary-color), #1e7fa3);\n  border-radius: 16px;\n  color: white;\n  box-shadow: 0 8px 24px rgba(45, 156, 219, 0.2);\n  animation: fadeInScale 0.6s ease-out 0.3s both;\n}\n\nbody.dark-mode .cart-summary {\n  background: linear-gradient(135deg, #0f172a, #1a2f4a);\n  border: 1px solid #334155;\n}\n\n.cart-total-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.total-label {\n  font-size: 1rem;\n  font-weight: 500;\n  opacity: 0.95;\n  margin: 0;\n}\n\n.total-amount {\n  font-size: 2rem;\n  font-weight: 800;\n  margin: 0;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.btn-checkout {\n  padding: 1rem 3rem;\n  background: white;\n  color: var(--primary-color);\n  border: none;\n  border-radius: 10px;\n  font-size: 1.1rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-width: 250px;\n}\n\n.btn-checkout:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n  background: #f0f9ff;\n}\n\n.btn-checkout:active {\n  transform: translateY(0);\n}\n\nbody.dark-mode .btn-checkout {\n  background: #e2e8f0;\n  color: #0f172a;\n}\n\nbody.dark-mode .btn-checkout:hover {\n  background: #f0f9ff;\n}\n\n.empty-cart {\n  min-height: 50vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n  color: var(--text-muted);\n  text-align: center;\n  padding: 3rem;\n}\n\nbody.dark-mode .empty-cart {\n  color: #94a3b8;\n}\n\n/* ================ BANNER ================ */\n\n.banner-wrapper {\n  width: 62%;\n  margin: 0 auto;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n}\n\n@media screen and (max-width: 768px) {\n  .banner-wrapper {\n    width: 90%;\n  }\n}\n@media screen and (max-width: 1900px) {\n  .banner-wrapper {\n    width: 80%;\n  }\n}\n\n\n.animated-banner {\n  width: 100%;\n  height: 420px;\n  overflow: hidden;\n  border-radius: 0;\n  position: relative;\n  margin: 0;\n  box-shadow: none;\n  background: linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%);\n}\n\n.banner-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 0;\n}\n\n.banner-fallback {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  background: linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%);\n  color: #0f172a;\n  border-radius: 0;\n}\n\nbody.dark-mode .animated-banner {\n  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);\n}\n\nbody.dark-mode .banner-fallback {\n  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);\n  color: #e2e8f0;\n}\n\n.banner-fallback-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.5rem;\n  text-align: center;\n}\n\n.banner-fallback-icon {\n  width: 100px;\n  height: 100px;\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.9);\n  font-size: 3.5rem;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.15);\n}\n\n.banner-fallback-content strong {\n  display: block;\n  font-size: 1.5rem;\n  font-weight: 700;\n}\n\n.banner-fallback-content p {\n  margin: 0.5rem 0 0;\n  color: inherit;\n  opacity: 0.85;\n  font-size: 1rem;\n}\n\n.checkout-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.checkout-page main {\n  flex: 1; /* Pushes footer down */\n}\n\n/* ================ FOOTER ================ */\n.footer {\n  margin-top: auto;\n  padding: 24px 20px;\n  background: #f0f4f9;\n  color: #475569;\n  flex-shrink: 0;\n  width: 100%;\n  border-top: 1px solid #e2e8f0;\n}\n\n.footer-text,\n.footer-brand {\n  color: #475569;\n  font-size: 0.95rem;\n}\n\n.footer-brand {\n  font-weight: 600;\n}\n\n.footer-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.footer-left,\n.footer-right {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n/* ================ CHECKOUT ================ */\n.checkout-container {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 3rem 1.5rem;\n  background: linear-gradient(135deg, var(--surface) 0%, #f8fafb 100%);\n  border-radius: 16px;\n  box-shadow: 0 4px 16px rgba(45, 156, 219, 0.1);\n  direction: rtl;\n  display: flex;\n  flex-direction: column;\n  gap: 2.5rem;\n}\n\nbody.dark-mode .checkout-container {\n  background: linear-gradient(135deg, #1e293b 0%, #1a2536 100%);\n  border: 1px solid #334155;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);\n}\n\n.checkout-title {\n  text-align: center;\n  margin-bottom: 1.5rem;\n  color: var(--secondary-color);\n  font-size: 2rem;\n  font-weight: 700;\n  animation: slideInUp 0.6s ease-out;\n}\n\nbody.dark-mode .checkout-title {\n  color: #e2e8f0;\n}\n\n.checkout-form {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.checkout-form input,\n.checkout-form select {\n  padding: 0.875rem 1rem;\n  border-radius: 10px;\n  border: 1px solid var(--border);\n  font-size: 1rem;\n  font-family: 'Zain', sans-serif;\n  transition: all 0.3s ease;\n  background: var(--surface);\n  color: var(--text-dark);\n}\n\n.checkout-form input:focus,\n.checkout-form select:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(45, 156, 219, 0.1);\n}\n\nbody.dark-mode .checkout-form input,\nbody.dark-mode .checkout-form select {\n  background: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n\nbody.dark-mode .checkout-form input:focus,\nbody.dark-mode .checkout-form select:focus {\n  border-color: #60a5fa;\n  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.1);\n}\n\n/* ================ FORM SECTIONS ================ */\n.customer-info-section,\n.payment-method-section {\n  padding: 1.75rem;\n  background: linear-gradient(135deg, #ffffff 0%, #f9fafc 100%);\n  border-radius: 14px;\n  border: 1px solid var(--border);\n  transition: all 0.3s ease;\n}\n\nbody.dark-mode .customer-info-section,\nbody.dark-mode .payment-method-section {\n  background: linear-gradient(135deg, #1e293b 0%, #1a2536 100%);\n  border-color: #334155;\n}\n\n.full-name-input,\n.address-input {\n  padding: 0.875rem 1rem;\n  font-size: 1rem;\n  width: 100%;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  margin-bottom: 1rem;\n  font-family: 'Zain', sans-serif;\n  background: var(--surface);\n  color: var(--text-dark);\n  transition: all 0.3s ease;\n}\n\n.full-name-input:focus,\n.address-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(45, 156, 219, 0.1);\n}\n\nbody.dark-mode .full-name-input,\nbody.dark-mode .address-input {\n  background: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n\n.location-selectors {\n  display: flex;\n  gap: 1.5rem;\n  margin-bottom: 1rem;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.state-select,\n.district-select {\n  flex: 1;\n  min-width: 200px;\n  padding: 0.875rem 1rem;\n  font-size: 1rem;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  background: var(--surface);\n  color: var(--text-dark);\n  font-family: 'Zain', sans-serif;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.state-select:focus,\n.district-select:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(45, 156, 219, 0.1);\n}\n\nbody.dark-mode .state-select,\nbody.dark-mode .district-select {\n  background: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n\n/* ================ PAYMENT METHOD ================ */\n.payment-method-section {\n  margin-bottom: 0;\n}\n\n.payment-selector {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.payment-title {\n  font-weight: 600;\n  margin: 0;\n  white-space: nowrap;\n  color: var(--text-dark);\n  font-size: 1.05rem;\n}\n\nbody.dark-mode .payment-title {\n  color: #e2e8f0;\n}\n\n.payment-type-select {\n  padding: 0.875rem 1.5rem;\n  border-radius: 10px;\n  border: 2px solid var(--primary-color);\n  min-width: 200px;\n  font-size: 1rem;\n  background: var(--surface);\n  color: var(--text-dark);\n  font-family: 'Zain', sans-serif;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n}\n\n.payment-type-select:hover {\n  border-color: var(--primary-hover);\n  box-shadow: 0 4px 12px rgba(45, 156, 219, 0.15);\n}\n\nbody.dark-mode .payment-type-select {\n  background: #1e293b;\n  border-color: #60a5fa;\n  color: #e2e8f0;\n}\n\n/* ================ ORDER SUMMARY ================ */\n.checkout-summary {\n  list-style: none;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 1.75rem;\n  margin-bottom: 2rem;\n}\n\n.checkout-summary li {\n  margin-bottom: 0;\n  animation: slideInUp 0.5s ease-out forwards;\n}\n\n.order-items-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 1.75rem;\n  margin-bottom: 2rem;\n  list-style: none;\n  padding: 0;\n}\n\n.order-item-card {\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  padding: 1.25rem;\n  background: linear-gradient(135deg, #ffffff 0%, #f9fafc 100%);\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);\n  text-align: center;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.order-item-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 12px 24px rgba(45, 156, 219, 0.15);\n  border-color: var(--primary-color);\n}\n\nbody.dark-mode .order-item-card {\n  background: linear-gradient(135deg, #1e293b 0%, #1a2536 100%);\n  border-color: #334155;\n}\n\n.order-item-image {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n  border-radius: 10px;\n  margin-bottom: 1rem;\n  background: var(--surface-soft);\n  border: 1px solid var(--border);\n}\n\n.order-item-details {\n  font-size: 1rem;\n  color: var(--text-dark);\n  margin-bottom: 0.75rem;\n}\n\nbody.dark-mode .order-item-details {\n  color: #e2e8f0;\n}\n\n.order-item-price {\n  font-weight: 700;\n  color: var(--primary-color);\n  font-size: 1.2rem;\n}\n\nbody.dark-mode .order-item-price {\n  color: #60a5fa;\n}\n\n.checkout-summary {\n  padding: 1.75rem;\n  background: linear-gradient(135deg, var(--primary-color), #1e7fa3);\n  border-radius: 14px;\n  color: white;\n  box-shadow: 0 8px 24px rgba(45, 156, 219, 0.2);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\nbody.dark-mode .checkout-summary {\n  background: linear-gradient(135deg, #0f172a, #1a2f4a);\n  border: 1px solid #334155;\n}\n\n.checkout-summary li {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.75rem 0;\n  font-size: 1.1rem;\n  font-weight: 500;\n  animation: none;\n}\n\n.checkout-summary li:last-child {\n  border-top: 2px solid rgba(255, 255, 255, 0.2);\n  padding-top: 1rem;\n  margin-top: 1rem;\n  font-size: 1.3rem;\n  font-weight: 700;\n}\n\n/* ================ OTP VERIFICATION ================ */\n.otp-verification-container {\n  max-width: 550px;\n  margin: 3rem auto;\n  padding: 2.5rem;\n  text-align: center;\n  border-radius: 16px;\n  border: 1px solid var(--border);\n  background: linear-gradient(135deg, var(--surface) 0%, #f8fafb 100%);\n  box-shadow: 0 8px 24px rgba(45, 156, 219, 0.12);\n}\n\nbody.dark-mode .otp-verification-container {\n  background: linear-gradient(135deg, #1e293b 0%, #1a2536 100%);\n  border-color: #334155;\n}\n\n.otp-title {\n  font-family: 'Tajawal', sans-serif;\n  margin-bottom: 1.5rem;\n  color: var(--secondary-color);\n  font-size: 1.8rem;\n  font-weight: 700;\n}\n\nbody.dark-mode .otp-title {\n  color: #e2e8f0;\n}\n\n.phone-input-container {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  width: 100%;\n}\n\n.country-select,\n.phone-input {\n  padding: 0.875rem 1rem;\n  font-size: 1rem;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  background: var(--surface);\n  color: var(--text-dark);\n  font-family: 'Zain', sans-serif;\n  transition: all 0.3s ease;\n}\n\n.country-select:focus,\n.phone-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(45, 156, 219, 0.1);\n}\n\nbody.dark-mode .country-select,\nbody.dark-mode .phone-input {\n  background: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n\n.phone-input {\n  flex: 1;\n}\n\n.otp-instructions {\n  margin-bottom: 1.5rem;\n  color: var(--text-muted);\n  font-size: 1.05rem;\n  line-height: 1.6;\n}\n\nbody.dark-mode .otp-instructions {\n  color: #94a3b8;\n}\n\n.otp-inputs-container {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: center;\n  margin-bottom: 2rem;\n}\n\n.otp-input {\n  width: 3.25rem;\n  height: 3.25rem;\n  text-align: center;\n  font-size: 1.5rem;\n  font-weight: 600;\n  border-radius: 10px;\n  border: 2px solid var(--border);\n  background: var(--surface);\n  color: var(--text-dark);\n  transition: all 0.3s ease;\n  font-family: 'Zain', sans-serif;\n}\n\n.otp-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(45, 156, 219, 0.1);\n}\n\nbody.dark-mode .otp-input {\n  background: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n\n.continue-button {\n  padding: 1rem 2.5rem;\n  background: linear-gradient(135deg, var(--primary-color), #1e7fa3);\n  color: white;\n  font-size: 1.1rem;\n  font-weight: 700;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  width: 100%;\n  max-width: 250px;\n  box-shadow: 0 4px 12px rgba(45, 156, 219, 0.25);\n}\n\n.continue-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(45, 156, 219, 0.35);\n}\n\n.continue-button:active {\n  transform: translateY(0);\n}\n\nbody.dark-mode .continue-button {\n  background: linear-gradient(135deg, #0f172a, #1a2f4a);\n  border: 1px solid #334155;\n}\n\nbody.dark-mode .continue-button:hover {\n  border-color: #60a5fa;\n}\n\n/* ================ UTILITY CLASSES ================ */\n.loading-text {\n  text-align: center;\n  font-size: 1.2rem;\n  margin-top: 50px;\n  color: var(--text-light);\n}\n\n.product-count {\n  color: #e72424;\n  font-size: 1.8rem;\n  text-align: left;\n  margin: 16px 0;\n}\n\n.banner-warning {\n  color: orange;\n  font-size: 0.85rem;\n  margin-top: 1px;\n}\n\n.toast-success {\n  background-color: #00C851 !important;\n  color: white;\n}\n\n.toast-error {\n  background-color: #ff4444 !important;\n  color: white;\n}\n\n/* ================ CHECKOUT STYLES ================ */\n.otp-verification-container {\n    max-width: 550px;\n    height: 400px;\n    margin: 4rem auto;\n    padding: 2rem;\n    text-align: center;\n    border-radius: 8px;\n    border: 1px solid #979cdb;\n    background-color: #ffffff;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n}\n\n.otp-title {\n    font-family: 'Tajawal', sans-serif;\n    margin-bottom: 1.5rem;\n    color: #333;\n    font-size: 1.5rem;\n}\n\n.phone-input-container {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 2rem;\n    width: 100%;\n}\n\n.country-select {\n    padding: 0.75rem;\n    font-size: 1rem;\n    border: 1px solid #ddd;\n    border-radius: 20px;\n    background-color: white;\n}\n\n.phone-input {\n    flex: 1;\n    padding: 0.75rem;\n    font-size: 1rem;\n    border: 1px solid #ddd;\n    border-radius: 20px;\n}\n\n.otp-instructions {\n    margin-bottom: 1.5rem;\n    color: #555;\n    font-size: 1.1rem;\n}\n\n.otp-inputs-container {\n    display: flex;\n    gap: 0.75rem;\n    justify-content: center;\n    margin-bottom: 2rem;\n}\n\n.otp-input {\n    width: 3rem;\n    height: 3rem;\n    text-align: center;\n    font-size: 1.5rem;\n    border-radius: 6px;\n    border: 1px solid #ddd;\n}\n\n.continue-button {\n    padding: 0.75rem 2rem;\n    background-color: #007b5e;\n    color: white;\n    font-size: 1rem;\n    border: none;\n    border-radius: 20px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    width: 100%;\n    max-width: 200px;\n}\n\n.continue-button:hover {\n    transform: scale(1.10);\n    color: aqua;\n}\n\n/* Checkout Form Styles */\n.checkout-title {\n    text-align: center;\n    margin-bottom: 2rem;\n    color: var(--secondary-color);\n    font-size: 1.8rem;\n    font-weight: 700;\n}\n\nbody.dark-mode .checkout-title {\n    color: #e2e8f0;\n}\n\n.customer-info-section {\n    margin-bottom: 2rem;\n    width: 100%;\n    padding: 1.75rem;\n    background: linear-gradient(135deg, #ffffff 0%, #f9fafc 100%);\n    border-radius: 14px;\n    border: 1px solid var(--border);\n}\n\nbody.dark-mode .customer-info-section {\n    background: linear-gradient(135deg, #1e293b 0%, #1a2536 100%);\n    border-color: #334155;\n}\n\n/* Payment Method Styles */\n.payment-method-section {\n    margin-bottom: 2rem;\n    padding: 1.75rem;\n    background: linear-gradient(135deg, #ffffff 0%, #f9fafc 100%);\n    border-radius: 14px;\n    border: 1px solid var(--border);\n}\n\nbody.dark-mode .payment-method-section {\n    background: linear-gradient(135deg, #1e293b 0%, #1a2536 100%);\n    border-color: #334155;\n}\n\n.location-selectors {\n    display: flex;\n    gap: 1.5rem;\n    margin-bottom: 1rem;\n    width: 100%;\n    flex-wrap: wrap;\n}\n\n/* Payment Method Styles */\n.payment-method-section {\n    margin-bottom: 2rem;\n    padding: 1.75rem;\n    background: linear-gradient(135deg, #ffffff 0%, #f9fafc 100%);\n    border-radius: 14px;\n    border: 1px solid var(--border);\n}\n\nbody.dark-mode .payment-method-section {\n    background: linear-gradient(135deg, #1e293b 0%, #1a2536 100%);\n    border-color: #334155;\n}\n\n.payment-selector {\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n    flex-wrap: wrap;\n}\n\n.payment-title {\n    font-weight: 600;\n    margin: 0;\n    white-space: nowrap;\n    color: var(--text-dark);\n    font-size: 1.05rem;\n}\n\nbody.dark-mode .payment-title {\n    color: #e2e8f0;\n}\n\n.payment-type-select {\n    padding: 0.875rem 1.5rem;\n    border-radius: 10px;\n    border: 2px solid var(--primary-color);\n    min-width: 200px;\n    font-size: 1rem;\n    background: var(--surface);\n    color: var(--text-dark);\n    font-family: 'Zain', sans-serif;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-weight: 500;\n}\n\n.payment-type-select:hover {\n    border-color: var(--primary-hover);\n    box-shadow: 0 4px 12px rgba(45, 156, 219, 0.15);\n}\n\nbody.dark-mode .payment-type-select {\n    background: #1e293b;\n    border-color: #60a5fa;\n    color: #e2e8f0;\n}\n\n.cash-icon {\n    color: var(--success);\n    font-size: 2rem;\n}\n\n/* Order Items Styles */\n.order-items-list {\n    list-style: none;\n    padding: 0;\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n    gap: 1.75rem;\n    margin-bottom: 2rem;\n}\n\n.order-item-card {\n    border: 1px solid var(--border);\n    border-radius: 14px;\n    padding: 1.25rem;\n    background: linear-gradient(135deg, #ffffff 0%, #f9fafc 100%);\n    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);\n    text-align: center;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.order-item-card:hover {\n    transform: translateY(-8px);\n    box-shadow: 0 12px 24px rgba(45, 156, 219, 0.15);\n    border-color: var(--primary-color);\n}\n\nbody.dark-mode .order-item-card {\n    background: linear-gradient(135deg, #1e293b 0%, #1a2536 100%);\n    border-color: #334155;\n}\n\n.order-item-image {\n    width: 100%;\n    height: 200px;\n    object-fit: cover;\n    border-radius: 10px;\n    margin-bottom: 1rem;\n    background: var(--surface-soft);\n    border: 1px solid var(--border);\n}\n\n.order-item-details {\n    font-size: 1rem;\n    color: var(--text-dark);\n    margin-bottom: 0.75rem;\n}\n\nbody.dark-mode .order-item-details {\n    color: #e2e8f0;\n}\n\n.order-item-price {\n    font-weight: 700;\n    color: var(--primary-color);\n    font-size: 1.2rem;\n}\n\nbody.dark-mode .order-item-price {\n    color: #60a5fa;\n}\n\n/* Order Summary Styles */\n.order-summary {\n    text-align: center;\n    margin-top: 2rem;\n    padding: 2rem;\n    background: linear-gradient(135deg, var(--primary-color), #1e7fa3);\n    border-radius: 14px;\n    color: white;\n    box-shadow: 0 8px 24px rgba(45, 156, 219, 0.2);\n}\n\nbody.dark-mode .order-summary {\n    background: linear-gradient(135deg, #0f172a, #1a2f4a);\n    border: 1px solid #334155;\n}\n\n.order-total {\n    margin-top: 1.5rem;\n    font-size: 1.8rem;\n    font-weight: 800;\n    color: white;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.place-order-button {\n    margin-top: 1.5rem;\n    padding: 1rem 2.5rem;\n    font-size: 1.1rem;\n    font-weight: 700;\n    background: white;\n    color: var(--primary-color);\n    border: none;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    width: 100%;\n    max-width: 300px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.place-order-button:hover {\n    background: #f0f9ff;\n    transform: translateY(-2px);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n}\n\n.place-order-button:active {\n    transform: translateY(0);\n}\n\nbody.dark-mode .place-order-button {\n    background: #e2e8f0;\n    color: #0f172a !important;\n}\n\nbody.dark-mode .place-order-button:hover {\n    background: #f0f9ff;\n}\n\n.empty-order-message {\n    text-align: center;\n    color: var(--text-muted);\n    font-size: 1.2rem;\n    margin: 2rem 0;\n    padding: 2rem;\n}\n\nbody.dark-mode .empty-order-message {\n    color: #94a3b8;\n}\n\n.responsive-table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.orders-history-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 800px; /* Ensures all columns fit side-by-side */\n}\n\n.orders-history-table th,\n.orders-history-table td {\n  padding: 0.75rem;\n  text-align: center;\n  border: 1px solid #ddd;\n}\n\n\n/* ================ MEDIA QUERIES ================ */\n\n@media screen and (max-width: 768px) {\n\n   .mobile-only {\n    display: block;\n  }\n  /* .desktop-only {\n    display: none;\n  } */\n\n  .navbar-container {\n    flex-direction: row; \n    justify-content: space-between;\n  }\n\n   .nav-title {\n    font-size: 1rem;\n  }\n\n  .nav-left {\n    order: 1; \n    flex: 1;\n    justify-content: flex-start;\n  }\n\n  .nav-right {\n    order: 2; \n    flex: 1;\n    justify-content: flex-end;\n    gap: 10px;\n  }\n\n  .nav-link {\n    font-size: 0.9rem;\n    padding: 5px;\n  }\n\n  /* Ensure home link is positioned correctly */\n  .nav-link:first-child {\n    margin-right: auto; /* Pushes other links to the right */\n  }\n\n   .banner-wrapper {\n    margin: 0 auto !important;\n    padding: 0 !important;\n  }\n  \n  .animated-banner {\n    margin: 2px auto; /* Very small vertical margin */\n  }\n  \n    .product-grid {\n    margin-top: 2px; /* Minimal space below banner */\n    padding: 0.9rem; /* Reduced grid padding */\n  }\n  \n  .banner-image {\n    width: 100%;\n    height: auto;\n    display: block;\n  }\n  \n   .page-center {\n    min-height: unset !important;\n    padding: 0.5rem !important;\n    display: block !important;\n  }\n\n\n}\n\n@media (max-width: 600px) {\n  .location-selectors {\n    flex-wrap: nowrap;\n    width: 100%; /* Optional: full width on mobile */\n    overflow-x: auto; /* Optional: horizontal scroll if needed */\n  }\n\n  .location-selectors select {\n    flex: 1 1 0; /* Allow flexible sizing */\n    min-width: 0;\n  }\n}\n\n\n/* Very small screens */\n@media screen and (max-width: 480px) {\n  .navbar-container {\n    flex-direction: row; \n    justify-content: space-between;\n  }\n\n  .nav-right {\n    gap: 5px;\n  }\n\n  .nav-title {\n    font-size: 0.9rem;\n  }\n\n  .nav-link {\n    font-size: 0.8rem;\n  }\n\n  \n\n.animated-banner {\n    max-width: 95%;\n  }\n  \n  .banner-fallback {\n    height: 120px;\n    font-size: 0.9rem;\n  } \n  \n  .otp-input {\n        width: 2rem;\n        height: 2rem;\n        font-size: 1.2rem;\n    }\n    \n    .order-items-list {\n        grid-template-columns: 1fr;\n    }\n    \n    .order-item-image {\n        height: 150px;\n    }\n}\n\n  /* Product Grid */\n@media (max-width: 768px) {  \n\n  .nav-phone {\n        font-size: 0.9rem;\n        color: #9ad12d;\n    }\n\n    .nav-cart {\n        font-size: 1rem;\n        color: white;\n    }\n\n    .hamburger-wrapper {\n    display: flex;\n    align-items: center;\n    margin: 0;\n  }\n\n   .desktop-only {\n    display: none;\n  }\n\n    .nav-logo {\n    padding-right: 0;\n    margin-right: 0;\n    width: 60px;\n  }\n\n  .nav-left {\n    /* display: flex;\n    align-items: center;\n    gap: 0px; space between hamburger and logo */\n    display: flex;\n  align-items: center;\n  gap: 0; /* Remove space between logo and hamburger */\n  flex-wrap: nowrap; /* Prevent wrapping */\n  overflow: hidden;\n\n  }\n\n  .product-grid {\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n    gap: 1rem;\n  }\n\n  .product-card {\n    padding: 12px;\n  }\n\n  .product-image {\n    height: 120px;\n  }\n\n  .product-info h3 {\n    font-size: 1rem;\n  }\n\n  .btn-add {\n    width: 100%;\n    padding: 8px 10px;\n    font-size: 0.6rem;\n  }\n  .btn-add:hover {\n  background-color: var(--primary-hover);\n  color: aqua;\n}\n\n  /* Cart */\n  .cart-container {\n    padding: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .cart-header {\n    width: 100%;\n    justify-content: center;\n    margin-bottom: 0.5rem;\n  }\n\n  .cart-header h2 {\n    font-size: 1.5rem;\n  }\n\n  .cart-list {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 1.25rem;\n    padding: 0;\n    list-style: none;\n    width: 100%;\n  }\n\n  .cart-card {\n    display: flex;\n    flex-direction: column;\n    background-color: #ffffff;\n    padding: 1.25rem;\n    border-radius: 12px;\n    gap: 1rem;\n    align-items: stretch;\n  }\n\n  .cart-image-wrapper {\n    height: 180px;\n    width: 100%;\n    order: -1;\n  }\n\n  .cart-item {\n    display: flex;\n    justify-content: center;\n  }\n\n  .cart-img {\n    width: 100%;\n    max-width: 100%;\n    border-radius: 8px;\n  }\n\n  .cart-name,\n  .cart-price,\n  .cart-controls,\n  .btn-remove {\n    margin: 0;\n    padding: 5px;\n    border-radius: 8px;\n    width: 100%;\n  }\n\n  .cart-controls button {\n    font-size: 20px;\n  }\n\n  .cart-summary {\n    width: 100%;\n    margin-top: 1.5rem;\n  }\n\n  .btn-checkout {\n    width: 100%;\n    min-width: auto;\n    padding: 0.75rem 1rem;\n    font-size: 1rem;\n  }\n\n  /* Checkout Responsive */\n  .checkout-container {\n    padding: 1.5rem;\n    margin: 1rem auto;\n  }\n\n  .checkout-title {\n    font-size: 1.5rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .customer-info-section,\n  .payment-method-section {\n    padding: 1.25rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .location-selectors {\n    flex-direction: column;\n    gap: 1rem;\n    width: 100%;\n  }\n\n  .state-select,\n  .district-select {\n    width: 100%;\n    min-width: auto;\n  }\n\n  .order-items-list {\n    grid-template-columns: 1fr;\n  }\n\n  .order-item-card {\n    padding: 1rem;\n  }\n\n  .order-item-image {\n    height: 150px;\n  }\n\n  .otp-verification-container {\n    padding: 1.5rem;\n    margin: 2rem 1rem;\n  }\n\n  .otp-inputs-container {\n    gap: 0.5rem;\n  }\n\n  .otp-input {\n    width: 2.75rem;\n    height: 2.75rem;\n    font-size: 1.2rem;\n  }\n\n  .continue-button {\n    padding: 0.875rem 1.5rem;\n    font-size: 1rem;\n    max-width: 100%;\n  }\n\n  .phone-input-container {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .country-select,\n  .phone-input {\n    width: 100%;\n  }\n\n  .place-order-button {\n    max-width: 100%;\n    padding: 0.875rem 1rem;\n  }\n  \n}\n\n@media (max-width: 480px) {\n  .product-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .product-info h3 {\n    font-size: 0.9rem;\n  }\n\n  .footer-container {\n    flex-direction: column;\n    gap: 15px;\n  }\n}\n\n/* Base style adjustments for mobile */\n@media (max-width: 767px) {\n  .product-card-details {\n    max-width: 90%;\n    margin: 20px auto;\n    padding: 16px;\n  }\n\n  .product-card-details {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n  .image-section {\n    order: -1; /* Move image to top if needed */\n    text-align: center;\n    width: 100%;\n  }\n\n  .details-image {\n    max-width: 100%;\n    height: auto;\n    margin: 0 auto;\n  }\n\n  .info-section {\n    padding: 10px 0;\n  }\n}\n\n@media (min-width: 768px) {\n  .product-details {\n    flex-direction: row;\n    justify-content: center;\n    align-items: flex-start;\n  }\n\n  .details-info {\n    text-align: center;\n  }\n\n  .cart-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;    \n    text-align: center;     \n    margin-right: 16px;     \n  }\n\n  .cart-content > * {\n  margin-bottom: 10px;\n}\n  \n}\n\n/* ================ GO BACK BUTTON ================ */\n.go-back-button {\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-hover) 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 0.75rem 1.5rem;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  box-shadow: 0 4px 12px rgba(45, 156, 219, 0.3);\n}\n\n.go-back-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(45, 156, 219, 0.4);\n  background: linear-gradient(135deg, var(--primary-hover) 0%, #1568b8 100%);\n}\n\n.go-back-button:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(45, 156, 219, 0.3);\n}\n\nbody.dark-mode .go-back-button {\n  background: linear-gradient(135deg, #4a9eff 0%, #2a7acc 100%);\n  box-shadow: 0 4px 12px rgba(74, 158, 255, 0.3);\n}\n\nbody.dark-mode .go-back-button:hover {\n  box-shadow: 0 6px 16px rgba(74, 158, 255, 0.4);\n  background: linear-gradient(135deg, #2a7acc 0%, #1a5a9f 100%);\n}\n\n@media (max-width: 480px) {\n  .go-back-button {\n    padding: 0.6rem 1.2rem;\n    font-size: 0.9rem;\n  }\n}\n\n/* ================ ANIMATIONS ================ */\n.fade-in {\n  animation: fadeIn 0.5s ease-in;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.shimmer::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -150%;\n  height: 100%;\n  width: 150%;\n  background: linear-gradient(to right, transparent 0%, rgba(255,255,255,0.1) 50%, transparent 100%);\n  animation: shimmer 1.5s infinite;\n}\n\n@keyframes shimmer {\n  0% { left: -150%; }\n  100% { left: 100%; }\n}\n\n/* ================ VARIANT PICKER ================ */\n.variant-picker {\n  margin: 1rem 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  width: 100%;\n}\n\n.variant-attribute {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  align-items: center;\n}\n\n.variant-attribute-label {\n  font-weight: 700;\n  color: var(--text-dark);\n  font-size: 0.95rem;\n}\n\nbody.dark-mode .variant-attribute-label {\n  color: #e2e8f0;\n}\n\n.variant-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n  justify-content: center;\n}\n\n.variant-option {\n  padding: 0.5rem 1.15rem;\n  border-radius: 20px;\n  border: 1px solid var(--border);\n  background: var(--surface);\n  color: var(--text-dark);\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-family: 'Zain', sans-serif;\n  transition: all 0.2s ease;\n}\n\n.variant-option:hover:not(.variant-option-disabled):not(.variant-option-selected) {\n  border-color: var(--primary-color);\n  color: var(--primary-color);\n  transform: translateY(-1px);\n}\n\n.variant-option-selected {\n  background: var(--primary-color);\n  border-color: var(--primary-color);\n  color: #fff;\n  font-weight: 700;\n}\n\n.variant-option-selected:hover {\n  background: var(--primary-hover);\n  border-color: var(--primary-hover);\n  transform: translateY(-1px);\n}\n\n.variant-option-disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  text-decoration: line-through;\n}\n\nbody.dark-mode .variant-option {\n  background: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n\nbody.dark-mode .variant-option:hover:not(.variant-option-disabled):not(.variant-option-selected) {\n  border-color: #60a5fa;\n  color: #60a5fa;\n}\n\nbody.dark-mode .variant-option-selected {\n  background: #2d9cdb;\n  border-color: #2d9cdb;\n  color: #fff;\n}\n\nbody.dark-mode .variant-option-disabled {\n  opacity: 0.35;\n}\n\n/* Disabled add-to-cart state (used while a variant product has no full\n   selection yet) */\n.add-to-cart-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.add-to-cart-btn:disabled:hover {\n  background-color: var(--surface);\n  color: inherit;\n  transform: none;\n}\n\n.btn-add:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-add:disabled:hover {\n  background-color: var(--pure-white, #fff);\n  color: inherit;\n}\n\n/* ================ CART LINE VARIANT TEXT ================ */\n.cart-variant-text {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  margin: 0;\n  text-align: right;\n}\n\nbody.dark-mode .cart-variant-text {\n  color: #94a3b8;\n}\n\n/* ================ STOCK TEXT ================ */\n.stock-text {\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin: 0.5rem 0 0 0;\n}\n\n.stock-available {\n  color: var(--success);\n}\n\n.stock-out {\n  color: var(--danger);\n}\n\nbody.dark-mode .stock-available {\n  color: #4ade80;\n}\n\nbody.dark-mode .stock-out {\n  color: #f87171;\n}\n\n@media (max-width: 480px) {\n  .variant-option {\n    padding: 0.45rem 0.9rem;\n    font-size: 0.85rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
